webpackJsonp([2],{

/***/ 147:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export merge */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return get; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createParser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createStyleFunction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return system; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return compose; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_object_assign__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_object_assign__);

var merge = function merge(a, b) {
  var result = __WEBPACK_IMPORTED_MODULE_0_object_assign___default()({}, a, b);

  for (var key in a) {
    var _assign;

    if (!a[key] || typeof b[key] !== 'object') continue;
    __WEBPACK_IMPORTED_MODULE_0_object_assign___default()(result, (_assign = {}, _assign[key] = __WEBPACK_IMPORTED_MODULE_0_object_assign___default()(a[key], b[key]), _assign));
  }

  return result;
}; // sort object-value responsive styles

var sort = function sort(obj) {
  var next = {};
  Object.keys(obj).sort(function (a, b) {
    return a.localeCompare(b, undefined, {
      numeric: true,
      sensitivity: 'base'
    });
  }).forEach(function (key) {
    next[key] = obj[key];
  });
  return next;
};

var defaults = {
  breakpoints: [40, 52, 64].map(function (n) {
    return n + 'em';
  })
};

var createMediaQuery = function createMediaQuery(n) {
  return "@media screen and (min-width: " + n + ")";
};

var getValue = function getValue(n, scale) {
  return get(scale, n, n);
};

var get = function get(obj, key, def, p, undef) {
  key = key && key.split ? key.split('.') : [key];

  for (p = 0; p < key.length; p++) {
    obj = obj ? obj[key[p]] : undef;
  }

  return obj === undef ? def : obj;
};
var createParser = function createParser(config) {
  var cache = {};

  var parse = function parse(props) {
    var styles = {};
    var shouldSort = false;
    var isCacheDisabled = props.theme && props.theme.disableStyledSystemCache;

    for (var key in props) {
      if (!config[key]) continue;
      var sx = config[key];
      var raw = props[key];
      var scale = get(props.theme, sx.scale, sx.defaults);

      if (typeof raw === 'object') {
        cache.breakpoints = !isCacheDisabled && cache.breakpoints || get(props.theme, 'breakpoints', defaults.breakpoints);

        if (Array.isArray(raw)) {
          cache.media = !isCacheDisabled && cache.media || [null].concat(cache.breakpoints.map(createMediaQuery));
          styles = merge(styles, parseResponsiveStyle(cache.media, sx, scale, raw, props));
          continue;
        }

        if (raw !== null) {
          styles = merge(styles, parseResponsiveObject(cache.breakpoints, sx, scale, raw, props));
          shouldSort = true;
        }

        continue;
      }

      __WEBPACK_IMPORTED_MODULE_0_object_assign___default()(styles, sx(raw, scale, props));
    } // sort object-based responsive styles


    if (shouldSort) {
      styles = sort(styles);
    }

    return styles;
  };

  parse.config = config;
  parse.propNames = Object.keys(config);
  parse.cache = cache;
  var keys = Object.keys(config).filter(function (k) {
    return k !== 'config';
  });

  if (keys.length > 1) {
    keys.forEach(function (key) {
      var _createParser;

      parse[key] = createParser((_createParser = {}, _createParser[key] = config[key], _createParser));
    });
  }

  return parse;
};

var parseResponsiveStyle = function parseResponsiveStyle(mediaQueries, sx, scale, raw, _props) {
  var styles = {};
  raw.slice(0, mediaQueries.length).forEach(function (value, i) {
    var media = mediaQueries[i];
    var style = sx(value, scale, _props);

    if (!media) {
      __WEBPACK_IMPORTED_MODULE_0_object_assign___default()(styles, style);
    } else {
      var _assign2;

      __WEBPACK_IMPORTED_MODULE_0_object_assign___default()(styles, (_assign2 = {}, _assign2[media] = __WEBPACK_IMPORTED_MODULE_0_object_assign___default()({}, styles[media], style), _assign2));
    }
  });
  return styles;
};

var parseResponsiveObject = function parseResponsiveObject(breakpoints, sx, scale, raw, _props) {
  var styles = {};

  for (var key in raw) {
    var breakpoint = breakpoints[key];
    var value = raw[key];
    var style = sx(value, scale, _props);

    if (!breakpoint) {
      __WEBPACK_IMPORTED_MODULE_0_object_assign___default()(styles, style);
    } else {
      var _assign3;

      var media = createMediaQuery(breakpoint);
      __WEBPACK_IMPORTED_MODULE_0_object_assign___default()(styles, (_assign3 = {}, _assign3[media] = __WEBPACK_IMPORTED_MODULE_0_object_assign___default()({}, styles[media], style), _assign3));
    }
  }

  return styles;
};

var createStyleFunction = function createStyleFunction(_ref) {
  var properties = _ref.properties,
      property = _ref.property,
      scale = _ref.scale,
      _ref$transform = _ref.transform,
      transform = _ref$transform === void 0 ? getValue : _ref$transform,
      defaultScale = _ref.defaultScale;
  properties = properties || [property];

  var sx = function sx(value, scale, _props) {
    var result = {};
    var n = transform(value, scale, _props);
    if (n === null) return;
    properties.forEach(function (prop) {
      result[prop] = n;
    });
    return result;
  };

  sx.scale = scale;
  sx.defaults = defaultScale;
  return sx;
}; // new v5 API

var system = function system(args) {
  if (args === void 0) {
    args = {};
  }

  var config = {};
  Object.keys(args).forEach(function (key) {
    var conf = args[key];

    if (conf === true) {
      // shortcut definition
      config[key] = createStyleFunction({
        property: key,
        scale: key
      });
      return;
    }

    if (typeof conf === 'function') {
      config[key] = conf;
      return;
    }

    config[key] = createStyleFunction(conf);
  });
  var parser = createParser(config);
  return parser;
};
var compose = function compose() {
  var config = {};

  for (var _len = arguments.length, parsers = new Array(_len), _key = 0; _key < _len; _key++) {
    parsers[_key] = arguments[_key];
  }

  parsers.forEach(function (parser) {
    if (!parser || !parser.config) return;
    __WEBPACK_IMPORTED_MODULE_0_object_assign___default()(config, parser.config);
  });
  var parser = createParser(config);
  return parser;
};


/***/ }),

/***/ 152:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return border; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styled_system_core__ = __webpack_require__(147);

var config = {
  border: {
    property: 'border',
    scale: 'borders'
  },
  borderWidth: {
    property: 'borderWidth',
    scale: 'borderWidths'
  },
  borderStyle: {
    property: 'borderStyle',
    scale: 'borderStyles'
  },
  borderColor: {
    property: 'borderColor',
    scale: 'colors'
  },
  borderRadius: {
    property: 'borderRadius',
    scale: 'radii'
  },
  borderTop: {
    property: 'borderTop',
    scale: 'borders'
  },
  borderTopLeftRadius: {
    property: 'borderTopLeftRadius',
    scale: 'radii'
  },
  borderTopRightRadius: {
    property: 'borderTopRightRadius',
    scale: 'radii'
  },
  borderRight: {
    property: 'borderRight',
    scale: 'borders'
  },
  borderBottom: {
    property: 'borderBottom',
    scale: 'borders'
  },
  borderBottomLeftRadius: {
    property: 'borderBottomLeftRadius',
    scale: 'radii'
  },
  borderBottomRightRadius: {
    property: 'borderBottomRightRadius',
    scale: 'radii'
  },
  borderLeft: {
    property: 'borderLeft',
    scale: 'borders'
  },
  borderX: {
    properties: ['borderLeft', 'borderRight'],
    scale: 'borders'
  },
  borderY: {
    properties: ['borderTop', 'borderBottom'],
    scale: 'borders'
  }
};
config.borderTopWidth = {
  property: 'borderTopWidth',
  scale: 'borderWidths'
};
config.borderTopColor = {
  property: 'borderTopColor',
  scale: 'colors'
};
config.borderTopStyle = {
  property: 'borderTopStyle',
  scale: 'borderStyles'
};
config.borderTopLeftRadius = {
  property: 'borderTopLeftRadius',
  scale: 'radii'
};
config.borderTopRightRadius = {
  property: 'borderTopRightRadius',
  scale: 'radii'
};
config.borderBottomWidth = {
  property: 'borderBottomWidth',
  scale: 'borderWidths'
};
config.borderBottomColor = {
  property: 'borderBottomColor',
  scale: 'colors'
};
config.borderBottomStyle = {
  property: 'borderBottomStyle',
  scale: 'borderStyles'
};
config.borderBottomLeftRadius = {
  property: 'borderBottomLeftRadius',
  scale: 'radii'
};
config.borderBottomRightRadius = {
  property: 'borderBottomRightRadius',
  scale: 'radii'
};
config.borderLeftWidth = {
  property: 'borderLeftWidth',
  scale: 'borderWidths'
};
config.borderLeftColor = {
  property: 'borderLeftColor',
  scale: 'colors'
};
config.borderLeftStyle = {
  property: 'borderLeftStyle',
  scale: 'borderStyles'
};
config.borderRightWidth = {
  property: 'borderRightWidth',
  scale: 'borderWidths'
};
config.borderRightColor = {
  property: 'borderRightColor',
  scale: 'colors'
};
config.borderRightStyle = {
  property: 'borderRightStyle',
  scale: 'borderStyles'
};
var border = Object(__WEBPACK_IMPORTED_MODULE_0__styled_system_core__["e" /* system */])(config);
/* harmony default export */ __webpack_exports__["b"] = (border);


/***/ }),

/***/ 153:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactStatic = __webpack_require__(22);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//


var siteTitle = 'https://bit-ml.github.io';
var siteTwitter = '@Bitdefender';

exports.default = function (_ref) {
  var children = _ref.children,
      title = _ref.title,
      description = _ref.description,
      tagline = _ref.tagline,
      image = _ref.image,
      path = _ref.path,
      tags = _ref.tags;
  return _react2.default.createElement(
    _reactStatic.Head,
    null,
    children,
    path && _react2.default.createElement('link', { rel: 'canonical', href: path }),
    title && _react2.default.createElement(
      'title',
      null,
      title
    ),
    description && _react2.default.createElement('meta', { name: 'description', content: description }),
    tags && _react2.default.createElement('meta', { name: 'keywords', content: tags.join(',') }),
    title && _react2.default.createElement('meta', { property: 'og:title', content: title }),
    description && _react2.default.createElement('meta', { property: 'og:description', content: description }),
    siteTitle && _react2.default.createElement('meta', { property: 'og:site_name', content: siteTitle }),
    tags && tags.slice(0, 6).map(function (tag) {
      return _react2.default.createElement('meta', { key: tag, property: 'article:tag', content: tag });
    }),
    image && _react2.default.createElement('meta', { property: 'og:image', content: '' + siteTitle + image }),
    _react2.default.createElement('meta', { name: 'twitter:card', content: 'summary_large_image' }),
    siteTwitter && _react2.default.createElement('meta', { name: 'twitter:site', content: siteTwitter }),
    title && _react2.default.createElement('meta', { name: 'twitter:title', content: title }),
    description && _react2.default.createElement('meta', { name: 'twitter:description', content: description }),
    image && _react2.default.createElement('meta', { name: 'twitter:image', content: '' + siteTitle + image }),
    description && _react2.default.createElement('meta', { itemProp: 'description', content: description }),
    tags && _react2.default.createElement('meta', { itemProp: 'keywords', content: tags.join(',') }),
    image && _react2.default.createElement('meta', { itemProp: 'image', content: '' + siteTitle + image })
  );
};

/***/ }),

/***/ 154:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n    padding: 0 5rem;\n    justify-content: flex-end;\n    a {\n      padding: 0.5rem 1rem 0.25rem 1rem;\n    }\n  '], ['\n    padding: 0 5rem;\n    justify-content: flex-end;\n    a {\n      padding: 0.5rem 1rem 0.25rem 1rem;\n    }\n  ']);

var _reactStatic = __webpack_require__(22);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _styledComponentsBreakpoint = __webpack_require__(45);

var _styledComponentsBreakpoint2 = _interopRequireDefault(_styledComponentsBreakpoint);

var _styledComponents = __webpack_require__(13);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Nav = _styledComponents2.default.nav.withConfig({
  displayName: 'Navigation__Nav',
  componentId: 'qabwmo-0'
})(['width:100%;background:', ';padding:0 1rem;font-family:"Roboto",Helvetica,Arial,sans-serif;display:flex;justify-content:space-between;a{padding:0.5rem 0 0.25rem 0;font-style:normal;font-weight:500;line-height:23px;font-size:14px;text-align:right;text-transform:uppercase;color:', ';}a:last-child{padding:0.5rem;padding-right:0;}', ''], function (props) {
  return props.bgColor;
}, function (props) {
  return props.fontColor;
}, (0, _styledComponentsBreakpoint2.default)('desktop')(_templateObject));

exports.default = function (_ref) {
  var pageName = _ref.pageName;

  var bgColor = pageName === 'home' ? '#020100' : 'transparent';
  var fontColor = pageName === 'home' ? '#A8A8A8' : '#333';

  return _react2.default.createElement(
    'header',
    null,
    _react2.default.createElement(
      Nav,
      { bgColor: bgColor, fontColor: fontColor },
      _react2.default.createElement(
        _reactStatic.Link,
        { exact: true, to: '/' },
        'Home'
      ),
      _react2.default.createElement(
        _reactStatic.Link,
        { to: '/#research' },
        'Research'
      ),
      _react2.default.createElement(
        _reactStatic.Link,
        { to: '/#teams' },
        'Team'
      ),
      _react2.default.createElement(
        _reactStatic.Link,
        { to: '/teaching/lectures-and-courses' },
        'Teaching'
      )
    )
  );
};

/***/ }),

/***/ 157:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "width", function() { return width; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "height", function() { return height; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "minWidth", function() { return minWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "minHeight", function() { return minHeight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "maxWidth", function() { return maxWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "maxHeight", function() { return maxHeight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "size", function() { return size; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "verticalAlign", function() { return verticalAlign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "display", function() { return display; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "overflow", function() { return overflow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "overflowX", function() { return overflowX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "overflowY", function() { return overflowY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "opacity", function() { return opacity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fontSize", function() { return fontSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fontFamily", function() { return fontFamily; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fontWeight", function() { return fontWeight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lineHeight", function() { return lineHeight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "textAlign", function() { return textAlign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fontStyle", function() { return fontStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "letterSpacing", function() { return letterSpacing; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "alignItems", function() { return alignItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "alignContent", function() { return alignContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "justifyItems", function() { return justifyItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "justifyContent", function() { return justifyContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "flexWrap", function() { return flexWrap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "flexDirection", function() { return flexDirection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "flex", function() { return flex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "flexGrow", function() { return flexGrow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "flexShrink", function() { return flexShrink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "flexBasis", function() { return flexBasis; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "justifySelf", function() { return justifySelf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "alignSelf", function() { return alignSelf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "order", function() { return order; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "gridGap", function() { return gridGap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "gridColumnGap", function() { return gridColumnGap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "gridRowGap", function() { return gridRowGap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "gridColumn", function() { return gridColumn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "gridRow", function() { return gridRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "gridAutoFlow", function() { return gridAutoFlow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "gridAutoColumns", function() { return gridAutoColumns; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "gridAutoRows", function() { return gridAutoRows; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "gridTemplateColumns", function() { return gridTemplateColumns; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "gridTemplateRows", function() { return gridTemplateRows; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "gridTemplateAreas", function() { return gridTemplateAreas; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "gridArea", function() { return gridArea; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "borderWidth", function() { return borderWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "borderStyle", function() { return borderStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "borderColor", function() { return borderColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "borderTop", function() { return borderTop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "borderRight", function() { return borderRight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "borderBottom", function() { return borderBottom; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "borderLeft", function() { return borderLeft; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "borderRadius", function() { return borderRadius; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "backgroundImage", function() { return backgroundImage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "backgroundSize", function() { return backgroundSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "backgroundPosition", function() { return backgroundPosition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "backgroundRepeat", function() { return backgroundRepeat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "zIndex", function() { return zIndex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "top", function() { return top; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "right", function() { return right; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bottom", function() { return bottom; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "left", function() { return left; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "style", function() { return style; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styled_system_core__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styled_system_layout__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styled_system_color__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styled_system_typography__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styled_system_flexbox__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styled_system_grid__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styled_system_border__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styled_system_background__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styled_system_position__ = __webpack_require__(164);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "get", function() { return __WEBPACK_IMPORTED_MODULE_0__styled_system_core__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createParser", function() { return __WEBPACK_IMPORTED_MODULE_0__styled_system_core__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createStyleFunction", function() { return __WEBPACK_IMPORTED_MODULE_0__styled_system_core__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "compose", function() { return __WEBPACK_IMPORTED_MODULE_0__styled_system_core__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "system", function() { return __WEBPACK_IMPORTED_MODULE_0__styled_system_core__["e"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styled_system_space__ = __webpack_require__(179);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "margin", function() { return __WEBPACK_IMPORTED_MODULE_9__styled_system_space__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "padding", function() { return __WEBPACK_IMPORTED_MODULE_9__styled_system_space__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "space", function() { return __WEBPACK_IMPORTED_MODULE_9__styled_system_space__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "color", function() { return __WEBPACK_IMPORTED_MODULE_2__styled_system_color__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "layout", function() { return __WEBPACK_IMPORTED_MODULE_1__styled_system_layout__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "typography", function() { return __WEBPACK_IMPORTED_MODULE_3__styled_system_typography__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "flexbox", function() { return __WEBPACK_IMPORTED_MODULE_4__styled_system_flexbox__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "border", function() { return __WEBPACK_IMPORTED_MODULE_6__styled_system_border__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "background", function() { return __WEBPACK_IMPORTED_MODULE_7__styled_system_background__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "position", function() { return __WEBPACK_IMPORTED_MODULE_8__styled_system_position__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "grid", function() { return __WEBPACK_IMPORTED_MODULE_5__styled_system_grid__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styled_system_shadow__ = __webpack_require__(165);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "shadow", function() { return __WEBPACK_IMPORTED_MODULE_10__styled_system_shadow__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "boxShadow", function() { return __WEBPACK_IMPORTED_MODULE_10__styled_system_shadow__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "textShadow", function() { return __WEBPACK_IMPORTED_MODULE_10__styled_system_shadow__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styled_system_variant__ = __webpack_require__(180);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "variant", function() { return __WEBPACK_IMPORTED_MODULE_11__styled_system_variant__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "buttonStyle", function() { return __WEBPACK_IMPORTED_MODULE_11__styled_system_variant__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "textStyle", function() { return __WEBPACK_IMPORTED_MODULE_11__styled_system_variant__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "colorStyle", function() { return __WEBPACK_IMPORTED_MODULE_11__styled_system_variant__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "borders", function() { return __WEBPACK_IMPORTED_MODULE_6__styled_system_border__["b"]; });
 // v4 api shims






















var width = __WEBPACK_IMPORTED_MODULE_1__styled_system_layout__["a" /* default */].width,
    height = __WEBPACK_IMPORTED_MODULE_1__styled_system_layout__["a" /* default */].height,
    minWidth = __WEBPACK_IMPORTED_MODULE_1__styled_system_layout__["a" /* default */].minWidth,
    minHeight = __WEBPACK_IMPORTED_MODULE_1__styled_system_layout__["a" /* default */].minHeight,
    maxWidth = __WEBPACK_IMPORTED_MODULE_1__styled_system_layout__["a" /* default */].maxWidth,
    maxHeight = __WEBPACK_IMPORTED_MODULE_1__styled_system_layout__["a" /* default */].maxHeight,
    size = __WEBPACK_IMPORTED_MODULE_1__styled_system_layout__["a" /* default */].size,
    verticalAlign = __WEBPACK_IMPORTED_MODULE_1__styled_system_layout__["a" /* default */].verticalAlign,
    display = __WEBPACK_IMPORTED_MODULE_1__styled_system_layout__["a" /* default */].display,
    overflow = __WEBPACK_IMPORTED_MODULE_1__styled_system_layout__["a" /* default */].overflow,
    overflowX = __WEBPACK_IMPORTED_MODULE_1__styled_system_layout__["a" /* default */].overflowX,
    overflowY = __WEBPACK_IMPORTED_MODULE_1__styled_system_layout__["a" /* default */].overflowY;
var opacity = __WEBPACK_IMPORTED_MODULE_2__styled_system_color__["b" /* default */].opacity;
var fontSize = __WEBPACK_IMPORTED_MODULE_3__styled_system_typography__["a" /* default */].fontSize,
    fontFamily = __WEBPACK_IMPORTED_MODULE_3__styled_system_typography__["a" /* default */].fontFamily,
    fontWeight = __WEBPACK_IMPORTED_MODULE_3__styled_system_typography__["a" /* default */].fontWeight,
    lineHeight = __WEBPACK_IMPORTED_MODULE_3__styled_system_typography__["a" /* default */].lineHeight,
    textAlign = __WEBPACK_IMPORTED_MODULE_3__styled_system_typography__["a" /* default */].textAlign,
    fontStyle = __WEBPACK_IMPORTED_MODULE_3__styled_system_typography__["a" /* default */].fontStyle,
    letterSpacing = __WEBPACK_IMPORTED_MODULE_3__styled_system_typography__["a" /* default */].letterSpacing;
var alignItems = __WEBPACK_IMPORTED_MODULE_4__styled_system_flexbox__["a" /* default */].alignItems,
    alignContent = __WEBPACK_IMPORTED_MODULE_4__styled_system_flexbox__["a" /* default */].alignContent,
    justifyItems = __WEBPACK_IMPORTED_MODULE_4__styled_system_flexbox__["a" /* default */].justifyItems,
    justifyContent = __WEBPACK_IMPORTED_MODULE_4__styled_system_flexbox__["a" /* default */].justifyContent,
    flexWrap = __WEBPACK_IMPORTED_MODULE_4__styled_system_flexbox__["a" /* default */].flexWrap,
    flexDirection = __WEBPACK_IMPORTED_MODULE_4__styled_system_flexbox__["a" /* default */].flexDirection,
    flex = __WEBPACK_IMPORTED_MODULE_4__styled_system_flexbox__["a" /* default */].flex,
    flexGrow = __WEBPACK_IMPORTED_MODULE_4__styled_system_flexbox__["a" /* default */].flexGrow,
    flexShrink = __WEBPACK_IMPORTED_MODULE_4__styled_system_flexbox__["a" /* default */].flexShrink,
    flexBasis = __WEBPACK_IMPORTED_MODULE_4__styled_system_flexbox__["a" /* default */].flexBasis,
    justifySelf = __WEBPACK_IMPORTED_MODULE_4__styled_system_flexbox__["a" /* default */].justifySelf,
    alignSelf = __WEBPACK_IMPORTED_MODULE_4__styled_system_flexbox__["a" /* default */].alignSelf,
    order = __WEBPACK_IMPORTED_MODULE_4__styled_system_flexbox__["a" /* default */].order;
var gridGap = __WEBPACK_IMPORTED_MODULE_5__styled_system_grid__["a" /* default */].gridGap,
    gridColumnGap = __WEBPACK_IMPORTED_MODULE_5__styled_system_grid__["a" /* default */].gridColumnGap,
    gridRowGap = __WEBPACK_IMPORTED_MODULE_5__styled_system_grid__["a" /* default */].gridRowGap,
    gridColumn = __WEBPACK_IMPORTED_MODULE_5__styled_system_grid__["a" /* default */].gridColumn,
    gridRow = __WEBPACK_IMPORTED_MODULE_5__styled_system_grid__["a" /* default */].gridRow,
    gridAutoFlow = __WEBPACK_IMPORTED_MODULE_5__styled_system_grid__["a" /* default */].gridAutoFlow,
    gridAutoColumns = __WEBPACK_IMPORTED_MODULE_5__styled_system_grid__["a" /* default */].gridAutoColumns,
    gridAutoRows = __WEBPACK_IMPORTED_MODULE_5__styled_system_grid__["a" /* default */].gridAutoRows,
    gridTemplateColumns = __WEBPACK_IMPORTED_MODULE_5__styled_system_grid__["a" /* default */].gridTemplateColumns,
    gridTemplateRows = __WEBPACK_IMPORTED_MODULE_5__styled_system_grid__["a" /* default */].gridTemplateRows,
    gridTemplateAreas = __WEBPACK_IMPORTED_MODULE_5__styled_system_grid__["a" /* default */].gridTemplateAreas,
    gridArea = __WEBPACK_IMPORTED_MODULE_5__styled_system_grid__["a" /* default */].gridArea;
var borderWidth = __WEBPACK_IMPORTED_MODULE_6__styled_system_border__["b" /* default */].borderWidth,
    borderStyle = __WEBPACK_IMPORTED_MODULE_6__styled_system_border__["b" /* default */].borderStyle,
    borderColor = __WEBPACK_IMPORTED_MODULE_6__styled_system_border__["b" /* default */].borderColor,
    borderTop = __WEBPACK_IMPORTED_MODULE_6__styled_system_border__["b" /* default */].borderTop,
    borderRight = __WEBPACK_IMPORTED_MODULE_6__styled_system_border__["b" /* default */].borderRight,
    borderBottom = __WEBPACK_IMPORTED_MODULE_6__styled_system_border__["b" /* default */].borderBottom,
    borderLeft = __WEBPACK_IMPORTED_MODULE_6__styled_system_border__["b" /* default */].borderLeft,
    borderRadius = __WEBPACK_IMPORTED_MODULE_6__styled_system_border__["b" /* default */].borderRadius;
var backgroundImage = __WEBPACK_IMPORTED_MODULE_7__styled_system_background__["b" /* default */].backgroundImage,
    backgroundSize = __WEBPACK_IMPORTED_MODULE_7__styled_system_background__["b" /* default */].backgroundSize,
    backgroundPosition = __WEBPACK_IMPORTED_MODULE_7__styled_system_background__["b" /* default */].backgroundPosition,
    backgroundRepeat = __WEBPACK_IMPORTED_MODULE_7__styled_system_background__["b" /* default */].backgroundRepeat;
var zIndex = __WEBPACK_IMPORTED_MODULE_8__styled_system_position__["a" /* default */].zIndex,
    top = __WEBPACK_IMPORTED_MODULE_8__styled_system_position__["a" /* default */].top,
    right = __WEBPACK_IMPORTED_MODULE_8__styled_system_position__["a" /* default */].right,
    bottom = __WEBPACK_IMPORTED_MODULE_8__styled_system_position__["a" /* default */].bottom,
    left = __WEBPACK_IMPORTED_MODULE_8__styled_system_position__["a" /* default */].left;

 // v4 style API shim

var style = function style(_ref) {
  var prop = _ref.prop,
      cssProperty = _ref.cssProperty,
      alias = _ref.alias,
      key = _ref.key,
      transformValue = _ref.transformValue,
      scale = _ref.scale,
      properties = _ref.properties;
  var config = {};
  config[prop] = Object(__WEBPACK_IMPORTED_MODULE_0__styled_system_core__["c" /* createStyleFunction */])({
    properties: properties,
    property: cssProperty || prop,
    scale: key,
    defaultScale: scale,
    transform: transformValue
  });
  if (alias) config[alias] = config[prop];
  var parse = Object(__WEBPACK_IMPORTED_MODULE_0__styled_system_core__["b" /* createParser */])(config);
  return parse;
};


/***/ }),

/***/ 158:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return layout; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styled_system_core__ = __webpack_require__(147);


var isNumber = function isNumber(n) {
  return typeof n === 'number' && !isNaN(n);
};

var getWidth = function getWidth(n, scale) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__styled_system_core__["d" /* get */])(scale, n, !isNumber(n) || n > 1 ? n : n * 100 + '%');
};

var config = {
  width: {
    property: 'width',
    scale: 'sizes',
    transform: getWidth
  },
  height: {
    property: 'height',
    scale: 'sizes'
  },
  minWidth: {
    property: 'minWidth',
    scale: 'sizes'
  },
  minHeight: {
    property: 'minHeight',
    scale: 'sizes'
  },
  maxWidth: {
    property: 'maxWidth',
    scale: 'sizes'
  },
  maxHeight: {
    property: 'maxHeight',
    scale: 'sizes'
  },
  size: {
    properties: ['width', 'height'],
    scale: 'sizes'
  },
  overflow: true,
  overflowX: true,
  overflowY: true,
  display: true,
  verticalAlign: true
};
var layout = Object(__WEBPACK_IMPORTED_MODULE_0__styled_system_core__["e" /* system */])(config);
/* harmony default export */ __webpack_exports__["a"] = (layout);


/***/ }),

/***/ 159:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return color; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styled_system_core__ = __webpack_require__(147);

var config = {
  color: {
    property: 'color',
    scale: 'colors'
  },
  backgroundColor: {
    property: 'backgroundColor',
    scale: 'colors'
  },
  opacity: true
};
config.bg = config.backgroundColor;
var color = Object(__WEBPACK_IMPORTED_MODULE_0__styled_system_core__["e" /* system */])(config);
/* harmony default export */ __webpack_exports__["b"] = (color);


/***/ }),

/***/ 160:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return typography; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styled_system_core__ = __webpack_require__(147);

var defaults = {
  fontSizes: [12, 14, 16, 20, 24, 32, 48, 64, 72]
};
var config = {
  fontFamily: {
    property: 'fontFamily',
    scale: 'fonts'
  },
  fontSize: {
    property: 'fontSize',
    scale: 'fontSizes',
    defaultScale: defaults.fontSizes
  },
  fontWeight: {
    property: 'fontWeight',
    scale: 'fontWeights'
  },
  lineHeight: {
    property: 'lineHeight',
    scale: 'lineHeights'
  },
  letterSpacing: {
    property: 'letterSpacing',
    scale: 'letterSpacings'
  },
  textAlign: true,
  fontStyle: true
};
var typography = Object(__WEBPACK_IMPORTED_MODULE_0__styled_system_core__["e" /* system */])(config);
/* harmony default export */ __webpack_exports__["a"] = (typography);


/***/ }),

/***/ 161:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return flexbox; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styled_system_core__ = __webpack_require__(147);

var config = {
  alignItems: true,
  alignContent: true,
  justifyItems: true,
  justifyContent: true,
  flexWrap: true,
  flexDirection: true,
  // item
  flex: true,
  flexGrow: true,
  flexShrink: true,
  flexBasis: true,
  justifySelf: true,
  alignSelf: true,
  order: true
};
var flexbox = Object(__WEBPACK_IMPORTED_MODULE_0__styled_system_core__["e" /* system */])(config);
/* harmony default export */ __webpack_exports__["a"] = (flexbox);


/***/ }),

/***/ 162:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return grid; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styled_system_core__ = __webpack_require__(147);

var defaults = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512]
};
var config = {
  gridGap: {
    property: 'gridGap',
    scale: 'space',
    defaultScale: defaults.space
  },
  gridColumnGap: {
    property: 'gridColumnGap',
    scale: 'space',
    defaultScale: defaults.space
  },
  gridRowGap: {
    property: 'gridRowGap',
    scale: 'space',
    defaultScale: defaults.space
  },
  gridColumn: true,
  gridRow: true,
  gridAutoFlow: true,
  gridAutoColumns: true,
  gridAutoRows: true,
  gridTemplateColumns: true,
  gridTemplateRows: true,
  gridTemplateAreas: true,
  gridArea: true
};
var grid = Object(__WEBPACK_IMPORTED_MODULE_0__styled_system_core__["e" /* system */])(config);
/* harmony default export */ __webpack_exports__["a"] = (grid);


/***/ }),

/***/ 163:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return background; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styled_system_core__ = __webpack_require__(147);

var config = {
  background: true,
  backgroundImage: true,
  backgroundSize: true,
  backgroundPosition: true,
  backgroundRepeat: true
};
config.bgImage = config.backgroundImage;
config.bgSize = config.backgroundSize;
config.bgPosition = config.backgroundPosition;
config.bgRepeat = config.backgroundRepeat;
var background = Object(__WEBPACK_IMPORTED_MODULE_0__styled_system_core__["e" /* system */])(config);
/* harmony default export */ __webpack_exports__["b"] = (background);


/***/ }),

/***/ 164:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return position; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styled_system_core__ = __webpack_require__(147);

var defaults = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512]
};
var config = {
  position: true,
  zIndex: {
    property: 'zIndex',
    scale: 'zIndices'
  },
  top: {
    property: 'top',
    scale: 'space',
    defaultScale: defaults.space
  },
  right: {
    property: 'right',
    scale: 'space',
    defaultScale: defaults.space
  },
  bottom: {
    property: 'bottom',
    scale: 'space',
    defaultScale: defaults.space
  },
  left: {
    property: 'left',
    scale: 'space',
    defaultScale: defaults.space
  }
};
var position = Object(__WEBPACK_IMPORTED_MODULE_0__styled_system_core__["e" /* system */])(config);
/* harmony default export */ __webpack_exports__["a"] = (position);


/***/ }),

/***/ 165:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return shadow; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styled_system_core__ = __webpack_require__(147);

var shadow = Object(__WEBPACK_IMPORTED_MODULE_0__styled_system_core__["e" /* system */])({
  boxShadow: {
    property: 'boxShadow',
    scale: 'shadows'
  },
  textShadow: {
    property: 'textShadow',
    scale: 'shadows'
  }
});
/* harmony default export */ __webpack_exports__["a"] = (shadow);


/***/ }),

/***/ 179:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return margin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return padding; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return space; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styled_system_core__ = __webpack_require__(147);

var defaults = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512]
};

var isNumber = function isNumber(n) {
  return typeof n === 'number' && !isNaN(n);
};

var getMargin = function getMargin(n, scale) {
  if (!isNumber(n)) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__styled_system_core__["d" /* get */])(scale, n, n);
  }

  var isNegative = n < 0;
  var absolute = Math.abs(n);
  var value = Object(__WEBPACK_IMPORTED_MODULE_0__styled_system_core__["d" /* get */])(scale, absolute, absolute);

  if (!isNumber(value)) {
    return isNegative ? '-' + value : value;
  }

  return value * (isNegative ? -1 : 1);
};

var configs = {};
configs.margin = {
  margin: {
    property: 'margin',
    scale: 'space',
    transform: getMargin,
    defaultScale: defaults.space
  },
  marginTop: {
    property: 'marginTop',
    scale: 'space',
    transform: getMargin,
    defaultScale: defaults.space
  },
  marginRight: {
    property: 'marginRight',
    scale: 'space',
    transform: getMargin,
    defaultScale: defaults.space
  },
  marginBottom: {
    property: 'marginBottom',
    scale: 'space',
    transform: getMargin,
    defaultScale: defaults.space
  },
  marginLeft: {
    property: 'marginLeft',
    scale: 'space',
    transform: getMargin,
    defaultScale: defaults.space
  },
  marginX: {
    properties: ['marginLeft', 'marginRight'],
    scale: 'space',
    transform: getMargin,
    defaultScale: defaults.space
  },
  marginY: {
    properties: ['marginTop', 'marginBottom'],
    scale: 'space',
    transform: getMargin,
    defaultScale: defaults.space
  }
};
configs.margin.m = configs.margin.margin;
configs.margin.mt = configs.margin.marginTop;
configs.margin.mr = configs.margin.marginRight;
configs.margin.mb = configs.margin.marginBottom;
configs.margin.ml = configs.margin.marginLeft;
configs.margin.mx = configs.margin.marginX;
configs.margin.my = configs.margin.marginY;
configs.padding = {
  padding: {
    property: 'padding',
    scale: 'space',
    defaultScale: defaults.space
  },
  paddingTop: {
    property: 'paddingTop',
    scale: 'space',
    defaultScale: defaults.space
  },
  paddingRight: {
    property: 'paddingRight',
    scale: 'space',
    defaultScale: defaults.space
  },
  paddingBottom: {
    property: 'paddingBottom',
    scale: 'space',
    defaultScale: defaults.space
  },
  paddingLeft: {
    property: 'paddingLeft',
    scale: 'space',
    defaultScale: defaults.space
  },
  paddingX: {
    properties: ['paddingLeft', 'paddingRight'],
    scale: 'space',
    defaultScale: defaults.space
  },
  paddingY: {
    properties: ['paddingTop', 'paddingBottom'],
    scale: 'space',
    defaultScale: defaults.space
  }
};
configs.padding.p = configs.padding.padding;
configs.padding.pt = configs.padding.paddingTop;
configs.padding.pr = configs.padding.paddingRight;
configs.padding.pb = configs.padding.paddingBottom;
configs.padding.pl = configs.padding.paddingLeft;
configs.padding.px = configs.padding.paddingX;
configs.padding.py = configs.padding.paddingY;
var margin = Object(__WEBPACK_IMPORTED_MODULE_0__styled_system_core__["e" /* system */])(configs.margin);
var padding = Object(__WEBPACK_IMPORTED_MODULE_0__styled_system_core__["e" /* system */])(configs.padding);
var space = Object(__WEBPACK_IMPORTED_MODULE_0__styled_system_core__["a" /* compose */])(margin, padding);
/* unused harmony default export */ var _unused_webpack_default_export = (space);


/***/ }),

/***/ 180:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return variant; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return buttonStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return textStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return colorStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styled_system_core__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styled_system_css__ = __webpack_require__(181);


var variant = function variant(_ref) {
  var _config;

  var scale = _ref.scale,
      _ref$prop = _ref.prop,
      prop = _ref$prop === void 0 ? 'variant' : _ref$prop,
      _ref$variants = _ref.variants,
      variants = _ref$variants === void 0 ? {} : _ref$variants,
      key = _ref.key;
  var sx;

  if (Object.keys(variants).length) {
    sx = function sx(value, scale, props) {
      return Object(__WEBPACK_IMPORTED_MODULE_1__styled_system_css__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__styled_system_core__["d" /* get */])(scale, value, null))(props.theme);
    };
  } else {
    sx = function sx(value, scale) {
      return Object(__WEBPACK_IMPORTED_MODULE_0__styled_system_core__["d" /* get */])(scale, value, null);
    };
  }

  sx.scale = scale || key;
  sx.defaults = variants;
  var config = (_config = {}, _config[prop] = sx, _config);
  var parser = Object(__WEBPACK_IMPORTED_MODULE_0__styled_system_core__["b" /* createParser */])(config);
  return parser;
};
/* unused harmony default export */ var _unused_webpack_default_export = (variant);
var buttonStyle = variant({
  key: 'buttons'
});
var textStyle = variant({
  key: 'textStyles',
  prop: 'textStyle'
});
var colorStyle = variant({
  key: 'colorStyles',
  prop: 'colors'
});


/***/ }),

/***/ 181:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export get */
/* unused harmony export responsive */
/* unused harmony export css */
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

// based on https://github.com/developit/dlv
var get = function get(obj, key, def, p, undef) {
  key = key && key.split ? key.split('.') : [key];

  for (p = 0; p < key.length; p++) {
    obj = obj ? obj[key[p]] : undef;
  }

  return obj === undef ? def : obj;
};
var defaultBreakpoints = [40, 52, 64].map(function (n) {
  return n + 'em';
});
var defaultTheme = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512],
  fontSizes: [12, 14, 16, 20, 24, 32, 48, 64, 72]
};
var aliases = {
  bg: 'backgroundColor',
  m: 'margin',
  mt: 'marginTop',
  mr: 'marginRight',
  mb: 'marginBottom',
  ml: 'marginLeft',
  mx: 'marginX',
  my: 'marginY',
  p: 'padding',
  pt: 'paddingTop',
  pr: 'paddingRight',
  pb: 'paddingBottom',
  pl: 'paddingLeft',
  px: 'paddingX',
  py: 'paddingY'
};
var multiples = {
  marginX: ['marginLeft', 'marginRight'],
  marginY: ['marginTop', 'marginBottom'],
  paddingX: ['paddingLeft', 'paddingRight'],
  paddingY: ['paddingTop', 'paddingBottom'],
  size: ['width', 'height']
};
var scales = {
  color: 'colors',
  backgroundColor: 'colors',
  borderColor: 'colors',
  margin: 'space',
  marginTop: 'space',
  marginRight: 'space',
  marginBottom: 'space',
  marginLeft: 'space',
  marginX: 'space',
  marginY: 'space',
  padding: 'space',
  paddingTop: 'space',
  paddingRight: 'space',
  paddingBottom: 'space',
  paddingLeft: 'space',
  paddingX: 'space',
  paddingY: 'space',
  top: 'space',
  right: 'space',
  bottom: 'space',
  left: 'space',
  gridGap: 'space',
  gridColumnGap: 'space',
  gridRowGap: 'space',
  gap: 'space',
  columnGap: 'space',
  rowGap: 'space',
  fontFamily: 'fonts',
  fontSize: 'fontSizes',
  fontWeight: 'fontWeights',
  lineHeight: 'lineHeights',
  letterSpacing: 'letterSpacings',
  border: 'borders',
  borderTop: 'borders',
  borderRight: 'borders',
  borderBottom: 'borders',
  borderLeft: 'borders',
  borderWidth: 'borderWidths',
  borderStyle: 'borderStyles',
  borderRadius: 'radii',
  borderTopRightRadius: 'radii',
  borderTopLeftRadius: 'radii',
  borderBottomRightRadius: 'radii',
  borderBottomLeftRadius: 'radii',
  borderTopWidth: 'borderWidths',
  borderTopColor: 'colors',
  borderTopStyle: 'borderStyles',
  borderBottomWidth: 'borderWidths',
  borderBottomColor: 'colors',
  borderBottomStyle: 'borderStyles',
  borderLeftWidth: 'borderWidths',
  borderLeftColor: 'colors',
  borderLeftStyle: 'borderStyles',
  borderRightWidth: 'borderWidths',
  borderRightColor: 'colors',
  borderRightStyle: 'borderStyles',
  outlineColor: 'colors',
  boxShadow: 'shadows',
  textShadow: 'shadows',
  zIndex: 'zIndices',
  width: 'sizes',
  minWidth: 'sizes',
  maxWidth: 'sizes',
  height: 'sizes',
  minHeight: 'sizes',
  maxHeight: 'sizes',
  flexBasis: 'sizes',
  size: 'sizes',
  // svg
  fill: 'colors',
  stroke: 'colors'
};

var positiveOrNegative = function positiveOrNegative(scale, value) {
  if (typeof value !== 'number' || value >= 0) {
    return get(scale, value, value);
  }

  var absolute = Math.abs(value);
  var n = get(scale, absolute, absolute);
  if (typeof n === 'string') return '-' + n;
  return n * -1;
};

var transforms = ['margin', 'marginTop', 'marginRight', 'marginBottom', 'marginLeft', 'marginX', 'marginY', 'top', 'bottom', 'left', 'right'].reduce(function (acc, curr) {
  var _extends2;

  return _extends({}, acc, (_extends2 = {}, _extends2[curr] = positiveOrNegative, _extends2));
}, {});
var responsive = function responsive(styles) {
  return function (theme) {
    var next = {};
    var breakpoints = get(theme, 'breakpoints', defaultBreakpoints);
    var mediaQueries = [null].concat(breakpoints.map(function (n) {
      return "@media screen and (min-width: " + n + ")";
    }));

    for (var key in styles) {
      var value = typeof styles[key] === 'function' ? styles[key](theme) : styles[key];
      if (value == null) continue;

      if (!Array.isArray(value)) {
        next[key] = value;
        continue;
      }

      for (var i = 0; i < value.slice(0, mediaQueries.length).length; i++) {
        var media = mediaQueries[i];

        if (!media) {
          next[key] = value[i];
          continue;
        }

        next[media] = next[media] || {};
        if (value[i] == null) continue;
        next[media][key] = value[i];
      }
    }

    return next;
  };
};
var css = function css(args) {
  return function (props) {
    if (props === void 0) {
      props = {};
    }

    var theme = _extends({}, defaultTheme, {}, props.theme || props);

    var result = {};
    var obj = typeof args === 'function' ? args(theme) : args;
    var styles = responsive(obj)(theme);

    for (var key in styles) {
      var x = styles[key];
      var val = typeof x === 'function' ? x(theme) : x;

      if (key === 'variant') {
        var variant = css(get(theme, val))(theme);
        result = _extends({}, result, {}, variant);
        continue;
      }

      if (val && typeof val === 'object') {
        result[key] = css(val)(theme);
        continue;
      }

      var prop = get(aliases, key, key);
      var scaleName = get(scales, prop);
      var scale = get(theme, scaleName, get(theme, prop, {}));
      var transform = get(transforms, prop, get);
      var value = transform(scale, val, val);

      if (multiples[prop]) {
        var dirs = multiples[prop];

        for (var i = 0; i < dirs.length; i++) {
          result[dirs[i]] = value;
        }
      } else {
        result[prop] = value;
      }
    }

    return result;
  };
};
/* harmony default export */ __webpack_exports__["a"] = (css);


/***/ }),

/***/ 182:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
  var children = _ref.children;
  return _react2.default.createElement(
    'main',
    null,
    children
  );
};

/***/ }),

/***/ 233:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Hero = undefined;

var _templateObject = _taggedTemplateLiteral(['\n    padding: 0 5rem;\n    height: 95vh;\n    background-size: contain;\n    background-position: bottom;\n    @media screen and (orientation:portrait) {\n      background-size: 1512px;\n      background-position: -700px bottom;\n    }\n  '], ['\n    padding: 0 5rem;\n    height: 95vh;\n    background-size: contain;\n    background-position: bottom;\n    @media screen and (orientation:portrait) {\n      background-size: 1512px;\n      background-position: -700px bottom;\n    }\n  ']),
    _templateObject2 = _taggedTemplateLiteral(['\n    padding: 0 5rem;\n    height: 95vh;\n    background-size: contain;\n    background-position: bottom;\n\n    @media screen and (orientation:portrait) {\n      background-size: 2048px;\n      background-position: -700px bottom;\n    }\n  '], ['\n    padding: 0 5rem;\n    height: 95vh;\n    background-size: contain;\n    background-position: bottom;\n\n    @media screen and (orientation:portrait) {\n      background-size: 2048px;\n      background-position: -700px bottom;\n    }\n  ']),
    _templateObject3 = _taggedTemplateLiteral(['\n    font-size: 64px;\n    line-height: 92px;\n  '], ['\n    font-size: 64px;\n    line-height: 92px;\n  ']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _styledComponents = __webpack_require__(13);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _styledComponentsBreakpoint = __webpack_require__(45);

var _styledComponentsBreakpoint2 = _interopRequireDefault(_styledComponentsBreakpoint);

var _Featured = __webpack_require__(234);

var _Featured2 = _interopRequireDefault(_Featured);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Hero = exports.Hero = _styledComponents2.default.div.withConfig({
  displayName: 'Hero',
  componentId: 'ajom9h-0'
})(['display:inline-block;width:100%;margin:0 auto;padding:0 1rem;background:#020100 url(\'/hero_avatar.webp\') no-repeat bottom;background-size:1024px;background-position:-600px bottom;min-height:92vh;@supports (-webkit-appearance:none){min-height:calc(92vh - 56px);}', ' ', ''], (0, _styledComponentsBreakpoint2.default)('tablet')(_templateObject), (0, _styledComponentsBreakpoint2.default)('desktop')(_templateObject2));

var Heading = _styledComponents2.default.h1.withConfig({
  displayName: 'Hero__Heading',
  componentId: 'ajom9h-1'
})(['max-width:800px;font-family:\'Exo 2\',sans-serif;font-style:normal;font-weight:500;font-size:32px;line-height:2.7rem;color:#E4E4E4;', ' ', ''], (0, _styledComponentsBreakpoint2.default)('tablet')(_templateObject3), (0, _styledComponentsBreakpoint2.default)('desktop')(_templateObject3));

exports.default = function (_ref) {
  var props = _ref.props;
  return _react2.default.createElement(
    Hero,
    null,
    _react2.default.createElement(
      Heading,
      null,
      props.tagline,
      ' '
    ),
    _react2.default.createElement(_Featured2.default, { props: props })
  );
};

/***/ }),

/***/ 234:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n    padding: 0 5rem;\n  '], ['\n    padding: 0 5rem;\n  ']),
    _templateObject2 = _taggedTemplateLiteral(['\n    padding: 0 5rem;\n\n    .carousel {\n      height: 33vh;\n    }\n  '], ['\n    padding: 0 5rem;\n\n    .carousel {\n      height: 33vh;\n    }\n  ']),
    _templateObject3 = _taggedTemplateLiteral(['\n    padding: 2rem 3rem;\n  '], ['\n    padding: 2rem 3rem;\n  ']),
    _templateObject4 = _taggedTemplateLiteral(['\n    font-size: 1.4rem;\n    line-height: 2rem;\n  '], ['\n    font-size: 1.4rem;\n    line-height: 2rem;\n  ']),
    _templateObject5 = _taggedTemplateLiteral(['\n    font-size: 1rem;\n    line-height: 1.4;\n  '], ['\n    font-size: 1rem;\n    line-height: 1.4;\n  ']),
    _templateObject6 = _taggedTemplateLiteral(['\n    left: 10px;\n    width: 70px;\n    height: 70px;\n    padding: 15px;\n  '], ['\n    left: 10px;\n    width: 70px;\n    height: 70px;\n    padding: 15px;\n  ']),
    _templateObject7 = _taggedTemplateLiteral(['\n    right: 10px;\n    width: 70px;\n    height: 70px;\n    padding: 15px;\n  '], ['\n    right: 10px;\n    width: 70px;\n    height: 70px;\n    padding: 15px;\n  ']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactStatic = __webpack_require__(22);

var _styledComponents = __webpack_require__(13);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _styledComponentsBreakpoint = __webpack_require__(45);

var _styledComponentsBreakpoint2 = _interopRequireDefault(_styledComponentsBreakpoint);

var _pureReactCarousel = __webpack_require__(235);

__webpack_require__(236);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var FeaturedContainer = _styledComponents2.default.div.withConfig({
  displayName: 'Featured__FeaturedContainer',
  componentId: 'xm4c49-0'
})(['background:rgba(24,27,42,0.8);left:0;bottom:0;position:absolute;width:100%;']);

var FeaturedWrapper = _styledComponents2.default.div.withConfig({
  displayName: 'Featured__FeaturedWrapper',
  componentId: 'xm4c49-1'
})(['margin:0 auto;padding:0 2.2rem;padding-bottom:0.5rem;color:#fff;.carousel{height:35vh;}', ' ', ''], (0, _styledComponentsBreakpoint2.default)('tablet')(_templateObject), (0, _styledComponentsBreakpoint2.default)('desktop')(_templateObject2));

var FeaturedLink = (0, _styledComponents2.default)(_reactStatic.Link).withConfig({
  displayName: 'Featured__FeaturedLink',
  componentId: 'xm4c49-2'
})(['display:block;width:100%;height:100%;background:rgba(98,118,207,0);transition:all 0.2s cubic-bezier(0.25,0.46,0.45,0.94);color:#e4e4e4;&:hover{color:#fff;background:rgba(98,118,207,0.3);}', ''], (0, _styledComponentsBreakpoint2.default)('desktop')(_templateObject3));

var FeaturedHeading = _styledComponents2.default.h2.withConfig({
  displayName: 'Featured__FeaturedHeading',
  componentId: 'xm4c49-3'
})(['font-family:"Exo 2",sans-serif;font-style:normal;font-weight:500;font-size:1rem;line-height:1.32rem;margin:0.4rem 0 0 0;color:#89cdf0;', ' ', ''], (0, _styledComponentsBreakpoint2.default)('tablet')(_templateObject4), (0, _styledComponentsBreakpoint2.default)('desktop')(_templateObject4));

var FeaturedSynopsis = _styledComponents2.default.p.withConfig({
  displayName: 'Featured__FeaturedSynopsis',
  componentId: 'xm4c49-4'
})(['font-size:0.833rem;font-weight:300;line-height:1.4;color:#fff;line-height:1rem;', ' ', ''], (0, _styledComponentsBreakpoint2.default)('tablet')(_templateObject5), (0, _styledComponentsBreakpoint2.default)('desktop')(_templateObject5));

var StyledButtonBack = (0, _styledComponents2.default)(_pureReactCarousel.ButtonBack).withConfig({
  displayName: 'Featured__StyledButtonBack',
  componentId: 'xm4c49-5'
})(['position:absolute;top:50%;left:-5px;margin-left:10px;margin-top:-20px;width:40px;height:40px;padding:10px;background:none;border:none;outline:none;border-radius:40px;', ' ', ''], (0, _styledComponentsBreakpoint2.default)('tablet')(_templateObject6), (0, _styledComponentsBreakpoint2.default)('desktop')(_templateObject6));
var StyledButtonNext = (0, _styledComponents2.default)(_pureReactCarousel.ButtonNext).withConfig({
  displayName: 'Featured__StyledButtonNext',
  componentId: 'xm4c49-6'
})(['position:absolute;top:50%;right:-5px;margin-right:10px;margin-top:-20px;width:40px;height:40px;padding:10px;background:none;border:none;outline:none;border-radius:40px;', ' ', ''], (0, _styledComponentsBreakpoint2.default)('tablet')(_templateObject7), (0, _styledComponentsBreakpoint2.default)('desktop')(_templateObject7));

exports.default = function (_ref) {
  var posts = _ref.posts;
  return _react2.default.createElement(
    FeaturedContainer,
    null,
    _react2.default.createElement(
      FeaturedWrapper,
      null,
      _react2.default.createElement(
        _pureReactCarousel.CarouselProvider,
        {
          naturalSlideWidth: 100,
          naturalSlideHeight: 125,
          totalSlides: 7
        },
        _react2.default.createElement(
          _pureReactCarousel.Slider,
          null,
          _react2.default.createElement(
            _pureReactCarousel.Slide,
            { index: 0 },
            _react2.default.createElement(
              FeaturedLink,
              { to: '/blog/post/fused-swiglu-kernel/' },
              _react2.default.createElement(
                FeaturedHeading,
                null,
                'Towards Fused Kernels for Gated MLP'
              ),
              _react2.default.createElement(
                FeaturedSynopsis,
                null,
                'Fusing the upscaling and gating in the Gated MLP.'
              )
            )
          ),
          _react2.default.createElement(
            _pureReactCarousel.Slide,
            { index: 1 },
            _react2.default.createElement(
              FeaturedLink,
              { to: '/blog/post/large-language-models-for-malware-analysis/' },
              _react2.default.createElement(
                FeaturedHeading,
                null,
                'Large Language Models for Malware Analysis'
              ),
              _react2.default.createElement(
                FeaturedSynopsis,
                null,
                'Leveraging Large Language Models to understand and generate assembly code.'
              )
            )
          ),
          _react2.default.createElement(
            _pureReactCarousel.Slide,
            { index: 2 },
            _react2.default.createElement(
              FeaturedLink,
              { to: '/blog/post/bgv-fully-homomorphic-encryption-scheme-in-python/' },
              _react2.default.createElement(
                FeaturedHeading,
                null,
                'The BGV fully homomorphic encryption scheme'
              ),
              _react2.default.createElement(
                FeaturedSynopsis,
                null,
                'The encryption, decryption, relinearization and the noise analysis of the Brakerski, Gentry, Vaikuntanathan (BGV) fully homomorphic encryption scheme.'
              )
            )
          ),
          _react2.default.createElement(
            _pureReactCarousel.Slide,
            { index: 3 },
            _react2.default.createElement(
              FeaturedLink,
              { to: '/blog/post/pretrained-atari-agents/' },
              _react2.default.createElement(
                FeaturedHeading,
                null,
                'Over 25,000 Atari trained agents published'
              ),
              _react2.default.createElement(
                FeaturedSynopsis,
                null,
                'We are making available trained models on 60 games in the Arcade Learning Environment.'
              )
            )
          ),
          _react2.default.createElement(
            _pureReactCarousel.Slide,
            { index: 4 },
            _react2.default.createElement(
              FeaturedLink,
              { to: '/blog/post/private-set-intersection-an-implementation-in-python/' },
              _react2.default.createElement(
                FeaturedHeading,
                null,
                'Private Set Intersection from Homomorphic Encryption: A Python Implementation'
              ),
              _react2.default.createElement(
                FeaturedSynopsis,
                null,
                'In which we discuss how to implement the PSI protocol using a HE encryption scheme, we introduce our new python library and describe various applications of PSI.'
              )
            )
          ),
          _react2.default.createElement(
            _pureReactCarousel.Slide,
            { index: 5 },
            _react2.default.createElement(
              FeaturedLink,
              { to: '/blog/post/homomorphic-encryption-toy-implementation-in-python/' },
              _react2.default.createElement(
                FeaturedHeading,
                null,
                'Homomorphic Encryption: a Toy Implementation in Python'
              ),
              _react2.default.createElement(
                FeaturedSynopsis,
                null,
                'Curious about how to work with data you can\'t see? In the this blog post we are going to broadly explain what Homomorphic Encryption is and how to implement a particular scheme.'
              )
            )
          ),
          _react2.default.createElement(
            _pureReactCarousel.Slide,
            { index: 6 },
            _react2.default.createElement(
              FeaturedLink,
              { to: '/teaching/lectures-and-courses/' },
              _react2.default.createElement(
                FeaturedHeading,
                null,
                'Bitdefender courses in Deep Learning and Crypto'
              ),
              _react2.default.createElement(
                FeaturedSynopsis,
                null,
                'Check out some of the courses delivered by our team in collaboration with top Universities in Bucharest. Includes slides and notebooks.'
              )
            )
          )
        ),
        _react2.default.createElement(
          StyledButtonBack,
          null,
          _react2.default.createElement(
            'span',
            null,
            _react2.default.createElement(
              'svg',
              {
                fill: '#fff',
                version: '1.1',
                xmlns: 'http://www.w3.org/2000/svg',
                xlink: 'http://www.w3.org/1999/xlink',
                x: '0px',
                y: '0px',
                width: '100%',
                height: '100%',
                viewBox: '0 0 512 512',
                space: 'preserve'
              },
              _react2.default.createElement('path', { d: 'M213.7,256L213.7,256L213.7,256L380.9,81.9c4.2-4.3,4.1-11.4-0.2-15.8l-29.9-30.6c-4.3-4.4-11.3-4.5-15.5-0.2L131.1,247.9 c-2.2,2.2-3.2,5.2-3,8.1c-0.1,3,0.9,5.9,3,8.1l204.2,212.7c4.2,4.3,11.2,4.2,15.5-0.2l29.9-30.6c4.3-4.4,4.4-11.5,0.2-15.8 L213.7,256z' })
            )
          )
        ),
        _react2.default.createElement(
          StyledButtonNext,
          null,
          _react2.default.createElement(
            'span',
            null,
            _react2.default.createElement(
              'svg',
              {
                fill: '#fff',
                version: '1.1',
                xmlns: 'http://www.w3.org/2000/svg',
                xlink: 'http://www.w3.org/1999/xlink',
                x: '0px',
                y: '0px',
                width: '100%',
                height: '100%',
                viewBox: '0 0 512 512',
                space: 'preserve'
              },
              _react2.default.createElement('path', { d: 'M298.3,256L298.3,256L298.3,256L131.1,81.9c-4.2-4.3-4.1-11.4,0.2-15.8l29.9-30.6c4.3-4.4,11.3-4.5,15.5-0.2l204.2,212.7 c2.2,2.2,3.2,5.2,3,8.1c0.1,3-0.9,5.9-3,8.1L176.7,476.8c-4.2,4.3-11.2,4.2-15.5-0.2L131.3,446c-4.3-4.4-4.4-11.5-0.2-15.8 L298.3,256z' })
            )
          )
        )
      )
    )
  );
};

// export default ({ posts }) => (
//   <FeaturedContainer>
//     <FeaturedWrapper>
//      {<FeaturedLink to="/blog/post/recurrent-space-time-graph-neural-nets/">
//         <FeaturedHeading>Recurrent Space-time Graph Neural Network</FeaturedHeading>
//         <FeaturedSynopsis>We introduce our recurrent graph model designed for
//         video processing from our new paper that will be presented at NeurIPS
//         2019 in Vancouver.
//         </FeaturedSynopsis>
//       </FeaturedLink>}
//      {<FeaturedLink to="/blog/post/bitdefender_at_eeml2019/">
//         <FeaturedHeading>Bitdefender at EEML 2019</FeaturedHeading>
//         <FeaturedSynopsis>Read about our team's experience of organizing and
//         participating at Eastern European Machine Learning summer school in
//         Bucharest.
//         </FeaturedSynopsis>
//       </FeaturedLink>}
//       <FeaturedLink to="/blog/post/bitdefender_at_tmlss2018/">
//         <FeaturedHeading>Bitdefender at TMLSS 2018</FeaturedHeading>
//         <FeaturedSynopsis>Bitdefender participated at the first edition of
//         the Transylvania Machine Learning Summer School that took place in
//         Cluj-Napoca.
//         </FeaturedSynopsis>
//       </FeaturedLink>
//     </FeaturedWrapper>
//   </FeaturedContainer>
// )

/***/ }),

/***/ 235:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ButtonBack", function() { return index; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ButtonFirst", function() { return index$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ButtonLast", function() { return index$3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ButtonNext", function() { return index$2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ButtonPlay", function() { return index$4; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CarouselProvider", function() { return CarouselProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Dot", function() { return Dot$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DotGroup", function() { return index$5; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Image", function() { return Image$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ImageWithZoom", function() { return index$6; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Slide", function() { return index$7; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Slider", function() { return index$8; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Spinner", function() { return Spinner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Store", function() { return Store; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WithStore", function() { return WithStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function _classCallCheck(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function _defineProperties(e,t){for(var r=0;r<t.length;r++){var i=t[r];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(e,i.key,i)}}function _createClass(e,t,r){return t&&_defineProperties(e.prototype,t),r&&_defineProperties(e,r),e}function _defineProperty(e,t,r){return t in e?Object.defineProperty(e,t,{value:r,enumerable:!0,configurable:!0,writable:!0}):e[t]=r,e}function _extends(){return(_extends=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var i in r)Object.prototype.hasOwnProperty.call(r,i)&&(e[i]=r[i])}return e}).apply(this,arguments)}function ownKeys(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);t&&(i=i.filter(function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable})),r.push.apply(r,i)}return r}function _objectSpread2(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{};t%2?ownKeys(Object(r),!0).forEach(function(t){_defineProperty(e,t,r[t])}):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):ownKeys(Object(r)).forEach(function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))})}return e}function _inherits(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&_setPrototypeOf(e,t)}function _getPrototypeOf(e){return(_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function _setPrototypeOf(e,t){return(_setPrototypeOf=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}function _objectWithoutPropertiesLoose(e,t){if(null==e)return{};var r,i,n={},s=Object.keys(e);for(i=0;i<s.length;i++)r=s[i],t.indexOf(r)>=0||(n[r]=e[r]);return n}function _objectWithoutProperties(e,t){if(null==e)return{};var r,i,n=_objectWithoutPropertiesLoose(e,t);if(Object.getOwnPropertySymbols){var s=Object.getOwnPropertySymbols(e);for(i=0;i<s.length;i++)r=s[i],t.indexOf(r)>=0||Object.prototype.propertyIsEnumerable.call(e,r)&&(n[r]=e[r])}return n}function _assertThisInitialized(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}function _possibleConstructorReturn(e,t){return!t||"object"!=typeof t&&"function"!=typeof t?_assertThisInitialized(e):t}function _toConsumableArray(e){return _arrayWithoutHoles(e)||_iterableToArray(e)||_nonIterableSpread()}function _arrayWithoutHoles(e){if(Array.isArray(e)){for(var t=0,r=new Array(e.length);t<e.length;t++)r[t]=e[t];return r}}function _iterableToArray(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}function _nonIterableSpread(){throw new TypeError("Invalid attempt to spread non-iterable instance")}function createCommonjsModule(e,t){return t={exports:{}},e(t,t.exports),t.exports}function emptyFunction(){}function emptyFunctionWithReset(){}function cn(e){return e.map(function(e){return!1===e?null:e}).join(" ").replace(/\s+/g," ").trim()}function slideSize(e,t){return 100/e*t/t}function slideTraySize(e,t){return 100*e/t}function pct(e){return"".concat(e,"%")}function equal(e,t,r){if(e===t)return!0;var i=types[jkrosoType(e)],n=types[jkrosoType(t)];return!(!i||i!==n)&&i(e,t,r)}function memoGaurd(e){return function(t,r,i){if(!i)return e(t,r,[]);for(var n,s=i.length;n=i[--s];)if(n[0]===t&&n[1]===r)return!0;return e(t,r,i)}}function arrayEqual(e,t,r){var i=e.length;if(i!==t.length)return!1;for(r.push([e,t]);i--;)if(!equal(e[i],t[i],r))return!1;return!0}function objectEqual(e,t,r){if("function"==typeof e.equal)return r.push([e,t]),e.equal(t,r);var i=getEnumerableProperties(e),n=getEnumerableProperties(t),s=i.length;if(s!==n.length)return!1;for(i.sort(),n.sort();s--;)if(i[s]!==n[s])return!1;for(r.push([e,t]),s=i.length;s--;){var o=i[s];if(!equal(e[o],t[o],r))return!1}return!0}function getEnumerableProperties(e){var t=[];for(var r in e)"constructor"!==r&&t.push(r);return t}function isNonNullObject(e){return!!e&&"object"==typeof e}function isSpecial(e){var t=Object.prototype.toString.call(e);return"[object RegExp]"===t||"[object Date]"===t||isReactElement(e)}function isReactElement(e){return e.$$typeof===REACT_ELEMENT_TYPE}function emptyTarget(e){return Array.isArray(e)?[]:{}}function cloneUnlessOtherwiseSpecified(e,t){return!1!==t.clone&&t.isMergeableObject(e)?deepmerge(emptyTarget(e),e,t):e}function defaultArrayMerge(e,t,r){return e.concat(t).map(function(e){return cloneUnlessOtherwiseSpecified(e,r)})}function mergeObject(e,t,r){var i={};return r.isMergeableObject(e)&&Object.keys(e).forEach(function(t){i[t]=cloneUnlessOtherwiseSpecified(e[t],r)}),Object.keys(t).forEach(function(n){r.isMergeableObject(t[n])&&e[n]?i[n]=deepmerge(e[n],t[n],r):i[n]=cloneUnlessOtherwiseSpecified(t[n],r)}),i}function deepmerge(e,t,r){(r=r||{}).arrayMerge=r.arrayMerge||defaultArrayMerge,r.isMergeableObject=r.isMergeableObject||isMergeableObject;var i=Array.isArray(t);return i===Array.isArray(e)?i?r.arrayMerge(e,t,r):mergeObject(e,t,r):cloneUnlessOtherwiseSpecified(t,r)}function WithStore(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:function(){return{}},r=function(r){function i(e,r){var n;return _classCallCheck(this,i),n=_possibleConstructorReturn(this,_getPrototypeOf(i).call(this,e,r)),n.state=t(_objectSpread2({},r.state)),n.updateStateProps=n.updateStateProps.bind(_assertThisInitialized(n)),n}return _inherits(i,r),_createClass(i,[{key:"componentDidMount",value:function(){this.context.subscribe(this.updateStateProps)}},{key:"shouldComponentUpdate",value:function(e,t){return!equals(t,this.state)||!equals(e,this.props)}},{key:"componentWillUnmount",value:function(){this.context.unsubscribe(this.updateStateProps)}},{key:"updateStateProps",value:function(){this.setState(t(_objectSpread2({},this.context.state)))}},{key:"render",value:function(){var t=this,r=deepmerge_1(this.state,this.props);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(e,_extends({ref:function(e){t.instance=e}},r,{carouselStore:{getStoreState:this.context.getStoreState,masterSpinnerError:this.context.masterSpinnerError,masterSpinnerSuccess:this.context.masterSpinnerSuccess,setStoreState:this.context.setStoreState,subscribeMasterSpinner:this.context.subscribeMasterSpinner,unsubscribeAllMasterSpinner:this.context.unsubscribeAllMasterSpinner,unsubscribeMasterSpinner:this.context.unsubscribeMasterSpinner}}),this.props.children)}}]),i}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);return _defineProperty(r,"contextType",Context),_defineProperty(r,"propTypes",{children:CarouselPropTypes.children}),_defineProperty(r,"defaultProps",{children:null}),r}var ReactPropTypesSecret="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED",ReactPropTypesSecret_1=ReactPropTypesSecret;emptyFunctionWithReset.resetWarningCache=emptyFunction;var factoryWithThrowingShims=function(){function e(e,t,r,i,n,s){if(s!==ReactPropTypesSecret_1){var o=new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");throw o.name="Invariant Violation",o}}function t(){return e}e.isRequired=e;var r={array:e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:t,element:e,elementType:e,instanceOf:t,node:e,objectOf:t,oneOf:t,oneOfType:t,shape:t,exact:t,checkPropTypes:emptyFunctionWithReset,resetWarningCache:emptyFunction};return r.PropTypes=r,r},propTypes=createCommonjsModule(function(e){e.exports=factoryWithThrowingShims()}),LOADING="loading",SUCCESS="success",ERROR="error",CarouselPropTypes={children:propTypes.oneOfType([propTypes.arrayOf(propTypes.node),propTypes.node]),direction:propTypes.oneOf(["forward","backward"]),height:function(e,t){var r=e[t];return"vertical"!==e.orientation||null!==r&&"number"==typeof r?null:new Error("Missing required property '".concat(t,"' when orientation is vertical.  You must supply a number representing the height in pixels"))},orientation:propTypes.oneOf(["horizontal","vertical"]),isBgImage:function(e,t){return!0===e[t]&&"img"===e.tag?new Error("HTML img elements should not have a backgroundImage.  Please use ".concat(t," for other block-level HTML tags, like div, a, section, etc...")):null}},boundedRange=function(e){var t=e.min,r=e.max,i=e.x;return Math.min(r,Math.max(t,i))},s={buttonBack:"buttonBack___1mlaL"},ButtonBack=function(e){function t(e){var r;return _classCallCheck(this,t),r=_possibleConstructorReturn(this,_getPrototypeOf(t).call(this,e)),r.handleOnClick=r.handleOnClick.bind(_assertThisInitialized(r)),r}return _inherits(t,e),_createClass(t,null,[{key:"setDisabled",value:function(e,t,r){return null!==e?e:0===t&&!r}}]),_createClass(t,[{key:"handleOnClick",value:function(e){var t=this.props,r=t.carouselStore,i=t.currentSlide,n=t.onClick,s=t.step,o=t.infinite,a=t.visibleSlides,l=t.totalSlides-a,c=Math.max(i-s,0);o&&(c=0===i?l:c),r.setStoreState({currentSlide:c},null!==n&&n.call(this,e))}},{key:"render",value:function(){var e=this.props,r=(e.carouselStore,e.className),i=(e.currentSlide,e.disabled,e.onClick,e.step,e.totalSlides,e.visibleSlides,e.infinite),n=_objectWithoutProperties(e,["carouselStore","className","currentSlide","disabled","onClick","step","totalSlides","visibleSlides","infinite"]),o=cn([s.buttonBack,"carousel__back-button",r]),a=t.setDisabled(this.props.disabled,this.props.currentSlide,i);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",_extends({type:"button","aria-label":"previous",className:o,onClick:this.handleOnClick,disabled:a},n),this.props.children)}}]),t}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);_defineProperty(ButtonBack,"propTypes",{carouselStore:propTypes.object.isRequired,children:CarouselPropTypes.children.isRequired,className:propTypes.string,currentSlide:propTypes.number.isRequired,disabled:propTypes.bool,onClick:propTypes.func,step:propTypes.number.isRequired,totalSlides:propTypes.number.isRequired,visibleSlides:propTypes.number.isRequired,infinite:propTypes.bool}),_defineProperty(ButtonBack,"defaultProps",{className:null,disabled:null,onClick:null,infinite:!1});var jkrosoType=createCommonjsModule(function(e,t){var r={}.toString,i="undefined"!=typeof window?window.Node:Function;e.exports=t=function(e){var t=typeof e;if("object"!=t)return t;if(t=n[r.call(e)],"object"==t)return e instanceof Map?"map":e instanceof Set?"set":"object";if(t)return t;if(e instanceof i)switch(e.nodeType){case 1:return"element";case 3:return"text-node";case 9:return"document";case 11:return"document-fragment";default:return"dom-node"}};var n=t.types={"[object Function]":"function","[object Date]":"date","[object RegExp]":"regexp","[object Arguments]":"arguments","[object Array]":"array","[object Set]":"set","[object String]":"string","[object Null]":"null","[object Undefined]":"undefined","[object Number]":"number","[object Boolean]":"boolean","[object Object]":"object","[object Map]":"map","[object Text]":"text-node","[object Uint8Array]":"bit-array","[object Uint16Array]":"bit-array","[object Uint32Array]":"bit-array","[object Uint8ClampedArray]":"bit-array","[object Error]":"error","[object FormData]":"form-data","[object File]":"file","[object Blob]":"blob"}}),jkrosoType_1=jkrosoType.types,types={};types.number=function(e,t){return e!==e&&t!==t},types.function=function(e,t,r){return e.toString()===t.toString()&&types.object(e,t,r)&&equal(e.prototype,t.prototype)},types.date=function(e,t){return+e==+t},types.regexp=function(e,t){return e.toString()===t.toString()},types.element=function(e,t){return e.outerHTML===t.outerHTML},types.textnode=function(e,t){return e.textContent===t.textContent},types.arguments=types["bit-array"]=types.array=memoGaurd(arrayEqual),types.object=memoGaurd(objectEqual);var equals=equal,isMergeableObject=function(e){return isNonNullObject(e)&&!isSpecial(e)},canUseSymbol="function"==typeof Symbol&&Symbol.for,REACT_ELEMENT_TYPE=canUseSymbol?Symbol.for("react.element"):60103;deepmerge.all=function(e,t){if(!Array.isArray(e))throw new Error("first argument should be an array");return e.reduce(function(e,r){return deepmerge(e,r,t)},{})};var deepmerge_1=deepmerge,Context=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext(),deepFreeze=function e(t){return Object.freeze(t),Object.getOwnPropertyNames(t).forEach(function(r){!t.hasOwnProperty(r)||null===t[r]||"object"!=typeof t[r]&&"function"!=typeof t[r]||Object.isFrozen(t[r])||e(t[r])}),t},DEFAULT_STATE={masterSpinnerFinished:!1},Store=function(){function e(t){_classCallCheck(this,e),this.state=deepFreeze(deepmerge_1(DEFAULT_STATE,t)),this.subscriptions=[],this.masterSpinnerSubscriptions={},this.setStoreState=this.setStoreState.bind(this),this.getStoreState=this.getStoreState.bind(this),this.subscribe=this.subscribe.bind(this),this.unsubscribe=this.unsubscribe.bind(this),this.updateSubscribers=this.updateSubscribers.bind(this),this.subscribeMasterSpinner=this.subscribeMasterSpinner.bind(this),this.unsubscribeMasterSpinner=this.unsubscribeMasterSpinner.bind(this),this.unsubscribeAllMasterSpinner=this.unsubscribeAllMasterSpinner.bind(this),this.masterSpinnerSuccess=this.masterSpinnerSuccess.bind(this),this.masterSpinnerError=this.masterSpinnerError.bind(this)}return _createClass(e,[{key:"setStoreState",value:function(e,t){this.state=deepFreeze(deepmerge_1(this.state,e)),this.updateSubscribers(t)}},{key:"getStoreState",value:function(){return deepmerge_1({},this.state)}},{key:"subscribe",value:function(e){this.subscriptions.push(e)}},{key:"unsubscribe",value:function(e){var t=this.subscriptions.indexOf(e);-1!==t&&this.subscriptions.splice(t,1)}},{key:"updateSubscribers",value:function(e){this.subscriptions.forEach(function(e){return e()}),"function"==typeof e&&e(this.getStoreState())}},{key:"subscribeMasterSpinner",value:function(e){-1===Object.keys(this.masterSpinnerSubscriptions).indexOf(e)&&(this.masterSpinnerSubscriptions[e]={success:!1,error:!1,complete:!1})}},{key:"unsubscribeMasterSpinner",value:function(e){return-1!==Object.keys(this.masterSpinnerSubscriptions).indexOf(e)&&(this.setMasterSpinnerFinished(),delete this.masterSpinnerSubscriptions[e])}},{key:"unsubscribeAllMasterSpinner",value:function(){this.masterSpinnerSubscriptions={},this.setMasterSpinnerFinished()}},{key:"masterSpinnerSuccess",value:function(e){this.masterSpinnerSubscriptions[e].success=!0,this.masterSpinnerSubscriptions[e].complete=!0,this.setMasterSpinnerFinished()}},{key:"masterSpinnerError",value:function(e){this.masterSpinnerSubscriptions[e].error=!0,this.masterSpinnerSubscriptions[e].complete=!0,this.setMasterSpinnerFinished()}},{key:"setMasterSpinnerFinished",value:function(){this.setStoreState({masterSpinnerFinished:this.isMasterSpinnerFinished()})}},{key:"isMasterSpinnerFinished",value:function(){var e=this;return!Object.keys(this.masterSpinnerSubscriptions).find(function(t){return!0!==e.masterSpinnerSubscriptions[t].complete})}}]),e}(),_class,_temp,CarouselProvider=(_temp=_class=function(e){function t(e){var r;_classCallCheck(this,t),r=_possibleConstructorReturn(this,_getPrototypeOf(t).call(this,e));var i={currentSlide:e.currentSlide,disableAnimation:e.disableAnimation,disableKeyboard:e.disableKeyboard,hasMasterSpinner:e.hasMasterSpinner,imageErrorCount:0,imageSuccessCount:0,interval:e.interval,isPageScrollLocked:e.isPageScrollLocked,isPlaying:e.isPlaying,lockOnWindowScroll:e.lockOnWindowScroll,masterSpinnerThreshold:0,naturalSlideHeight:e.naturalSlideHeight,naturalSlideWidth:e.naturalSlideWidth,orientation:e.orientation,playDirection:e.playDirection,privateUnDisableAnimation:!1,slideSize:slideSize(e.totalSlides,e.visibleSlides),slideTraySize:slideTraySize(e.totalSlides,e.visibleSlides),step:e.step,dragStep:e.dragStep,totalSlides:e.totalSlides,touchEnabled:e.touchEnabled,dragEnabled:e.dragEnabled,visibleSlides:e.visibleSlides,infinite:e.infinite};return r.carouselStore=new Store(i),r}return _inherits(t,e),_createClass(t,[{key:"componentDidUpdate",value:function(e){var t=this,r={};["currentSlide","disableAnimation","disableKeyboard","hasMasterSpinner","interval","isPlaying","naturalSlideHeight","naturalSlideWidth","lockOnWindowScroll","orientation","playDirection","step","dragStep","totalSlides","touchEnabled","dragEnabled","visibleSlides"].forEach(function(i){e[i]!==t.props[i]&&(r[i]=t.props[i])}),this.props.currentSlide!==e.currentSlide&&!this.props.disableAnimation&&(r.disableAnimation=!0,r.privateUnDisableAnimation=!0),this.props.totalSlides===e.totalSlides&&this.props.visibleSlides===e.visibleSlides||(r.slideSize=slideSize(this.props.totalSlides,this.props.visibleSlides),r.slideTraySize=slideTraySize(this.props.totalSlides,this.props.visibleSlides)),Object.keys(r).length>0&&this.carouselStore.setStoreState(r)}},{key:"componentWillUnmount",value:function(){this.carouselStore.unsubscribeAllMasterSpinner()}},{key:"getStore",value:function(){return this.carouselStore}},{key:"render",value:function(){var e=this.props,t=(e.children,e.className,e.currentSlide,e.disableAnimation,e.disableKeyboard,e.hasMasterSpinner,e.interval,e.isPageScrollLocked,e.isPlaying,e.lockOnWindowScroll,e.naturalSlideHeight,e.naturalSlideWidth,e.orientation,e.playDirection,e.step,e.dragStep,e.tag),r=(e.totalSlides,e.touchEnabled,e.dragEnabled,e.visibleSlides,e.infinite,_objectWithoutProperties(e,["children","className","currentSlide","disableAnimation","disableKeyboard","hasMasterSpinner","interval","isPageScrollLocked","isPlaying","lockOnWindowScroll","naturalSlideHeight","naturalSlideWidth","orientation","playDirection","step","dragStep","tag","totalSlides","touchEnabled","dragEnabled","visibleSlides","infinite"])),i=cn(["carousel",this.props.className]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(t,_extends({className:i},r),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Context.Provider,{value:this.carouselStore},this.props.children))}}]),t}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component),_defineProperty(_class,"propTypes",{children:CarouselPropTypes.children.isRequired,className:propTypes.string,currentSlide:propTypes.number,disableAnimation:propTypes.bool,disableKeyboard:propTypes.bool,hasMasterSpinner:propTypes.bool,interval:propTypes.number,isPageScrollLocked:propTypes.bool,isPlaying:propTypes.bool,lockOnWindowScroll:propTypes.bool,naturalSlideHeight:propTypes.number.isRequired,naturalSlideWidth:propTypes.number.isRequired,orientation:CarouselPropTypes.orientation,playDirection:CarouselPropTypes.direction,step:propTypes.number,dragStep:propTypes.number,tag:propTypes.string,totalSlides:propTypes.number.isRequired,touchEnabled:propTypes.bool,dragEnabled:propTypes.bool,visibleSlides:propTypes.number,infinite:propTypes.bool}),_defineProperty(_class,"defaultProps",{className:null,currentSlide:0,disableAnimation:!1,disableKeyboard:!1,hasMasterSpinner:!1,interval:5e3,isPageScrollLocked:!1,isPlaying:!1,lockOnWindowScroll:!1,orientation:"horizontal",playDirection:"forward",step:1,dragStep:1,tag:"div",touchEnabled:!0,dragEnabled:!0,visibleSlides:1,infinite:!1}),_temp);Context.Consumer;var index=WithStore(ButtonBack,function(e){return{currentSlide:e.currentSlide,step:e.step,totalSlides:e.totalSlides,visibleSlides:e.visibleSlides,infinite:e.infinite}}),s$1={buttonFirst:"buttonFirst___2rhFr"},_class$1,_temp$1,ButtonFirst=(_temp$1=_class$1=function(e){function t(){var e;return _classCallCheck(this,t),e=_possibleConstructorReturn(this,_getPrototypeOf(t).call(this)),e.handleOnClick=e.handleOnClick.bind(_assertThisInitialized(e)),e}return _inherits(t,e),_createClass(t,[{key:"handleOnClick",value:function(e){var t=this.props,r=t.carouselStore,i=t.onClick;r.setStoreState({currentSlide:0},null!==i&&i.call(this,e))}},{key:"render",value:function(){var e=this.props,t=(e.carouselStore,e.className),r=e.currentSlide,i=e.disabled,n=(e.onClick,e.totalSlides,_objectWithoutProperties(e,["carouselStore","className","currentSlide","disabled","onClick","totalSlides"])),s=cn([s$1.buttonFirst,"carousel__first-button",t]),o=null!==i?i:0===r;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",_extends({type:"button","aria-label":"first",className:s,onClick:this.handleOnClick,disabled:o},n),this.props.children)}}]),t}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component),_defineProperty(_class$1,"propTypes",{carouselStore:propTypes.object.isRequired,children:CarouselPropTypes.children.isRequired,className:propTypes.string,currentSlide:propTypes.number.isRequired,disabled:propTypes.bool,onClick:propTypes.func,totalSlides:propTypes.number.isRequired}),_defineProperty(_class$1,"defaultProps",{className:null,disabled:null,onClick:null}),_temp$1),index$1=WithStore(ButtonFirst,function(e){return{currentSlide:e.currentSlide,totalSlides:e.totalSlides}}),s$2={buttonNext:"buttonNext___2mOCa"},_class$2,_temp$2,ButtonNext=(_temp$2=_class$2=function(e){function t(e){var r;return _classCallCheck(this,t),r=_possibleConstructorReturn(this,_getPrototypeOf(t).call(this,e)),r.handleOnClick=r.handleOnClick.bind(_assertThisInitialized(r)),r}return _inherits(t,e),_createClass(t,null,[{key:"setDisabled",value:function(e,t,r,i,n){return null!==e?e:t>=i-r&&!n}}]),_createClass(t,[{key:"handleOnClick",value:function(e){var t=this.props,r=t.currentSlide,i=t.onClick,n=t.step,s=t.carouselStore,o=t.infinite,a=t.totalSlides-t.visibleSlides,l=n+r,c=Math.min(l,a);o&&(c=a===r?0:c),s.setStoreState({currentSlide:c},null!==i&&i.call(this,e))}},{key:"render",value:function(){var e=this.props,r=(e.carouselStore,e.className),i=e.currentSlide,n=e.disabled,s=(e.onClick,e.step,e.totalSlides),o=e.visibleSlides,a=e.infinite,l=_objectWithoutProperties(e,["carouselStore","className","currentSlide","disabled","onClick","step","totalSlides","visibleSlides","infinite"]),c=cn([s$2.buttonNext,"carousel__next-button",r]),u=t.setDisabled(n,i,o,s,a);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",_extends({type:"button","aria-label":"next",className:c,onClick:this.handleOnClick,disabled:u},l),this.props.children)}}]),t}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent),_defineProperty(_class$2,"propTypes",{carouselStore:propTypes.object.isRequired,children:CarouselPropTypes.children.isRequired,className:propTypes.string,currentSlide:propTypes.number.isRequired,disabled:propTypes.bool,onClick:propTypes.func,step:propTypes.number.isRequired,totalSlides:propTypes.number.isRequired,visibleSlides:propTypes.number.isRequired,infinite:propTypes.bool}),_defineProperty(_class$2,"defaultProps",{className:null,disabled:null,onClick:null,infinite:!1}),_temp$2),index$2=WithStore(ButtonNext,function(e){return{currentSlide:e.currentSlide,step:e.step,totalSlides:e.totalSlides,visibleSlides:e.visibleSlides,infinite:e.infinite}}),s$3={buttonLast:"buttonLast___2yuh0"},_class$3,_temp$3,ButtonLast=(_temp$3=_class$3=function(e){function t(){var e;return _classCallCheck(this,t),e=_possibleConstructorReturn(this,_getPrototypeOf(t).call(this)),e.handleOnClick=e.handleOnClick.bind(_assertThisInitialized(e)),e}return _inherits(t,e),_createClass(t,[{key:"handleOnClick",value:function(e){var t=this.props,r=t.carouselStore,i=t.onClick,n=t.totalSlides,s=t.visibleSlides;r.setStoreState({currentSlide:n-s},null!==i&&i.call(this,e))}},{key:"render",value:function(){var e=this.props,t=(e.carouselStore,e.className),r=e.currentSlide,i=e.disabled,n=(e.onClick,e.totalSlides),s=e.visibleSlides,o=_objectWithoutProperties(e,["carouselStore","className","currentSlide","disabled","onClick","totalSlides","visibleSlides"]),a=cn([s$3.buttonLast,"carousel__last-button",t]),l=null!==i?i:r>=n-s;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",_extends({type:"button","aria-label":"last",className:a,onClick:this.handleOnClick,disabled:l},o),this.props.children)}}]),t}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component),_defineProperty(_class$3,"propTypes",{carouselStore:propTypes.object.isRequired,children:CarouselPropTypes.children.isRequired,className:propTypes.string,currentSlide:propTypes.number.isRequired,disabled:propTypes.bool,onClick:propTypes.func,totalSlides:propTypes.number.isRequired,visibleSlides:propTypes.number.isRequired}),_defineProperty(_class$3,"defaultProps",{className:null,disabled:null,onClick:null}),_temp$3),index$3=WithStore(ButtonLast,function(e){return{currentSlide:e.currentSlide,totalSlides:e.totalSlides,visibleSlides:e.visibleSlides}}),s$4={buttonNext:"buttonNext___3Lm3s"},_class$4,_temp$4,ButtonPlay=(_temp$4=_class$4=function(e){function t(e){var r;return _classCallCheck(this,t),r=_possibleConstructorReturn(this,_getPrototypeOf(t).call(this,e)),r.handleOnClick=r.handleOnClick.bind(_assertThisInitialized(r)),r}return _inherits(t,e),_createClass(t,[{key:"handleOnClick",value:function(e){var t=this.props.onClick;this.props.carouselStore.setStoreState({isPlaying:!this.props.isPlaying},null!==t&&t.call(this,e))}},{key:"render",value:function(){var e=this.props,t=(e.carouselStore,e.children,e.childrenPaused),r=e.childrenPlaying,i=e.className,n=e.isPlaying,s=(e.onClick,_objectWithoutProperties(e,["carouselStore","children","childrenPaused","childrenPlaying","className","isPlaying","onClick"])),o=cn([s$4.buttonNext,"carousel__play-button",i]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",_extends({type:"button","aria-label":"play",className:o,onClick:this.handleOnClick},s),n&&r,!n&&t,this.props.children)}}]),t}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent),_defineProperty(_class$4,"propTypes",{carouselStore:propTypes.object.isRequired,children:propTypes.node,childrenPaused:propTypes.node,childrenPlaying:propTypes.node,className:propTypes.string,isPlaying:propTypes.bool.isRequired,onClick:propTypes.func}),_defineProperty(_class$4,"defaultProps",{children:null,childrenPaused:null,childrenPlaying:null,className:null,onClick:null}),_temp$4),index$4=WithStore(ButtonPlay,function(e){return{isPlaying:e.isPlaying}}),s$5={dot:"dot___3c3SI"},_class$5,_temp$5,Dot=(_temp$5=_class$5=function(e){function t(e){var r;return _classCallCheck(this,t),r=_possibleConstructorReturn(this,_getPrototypeOf(t).call(this,e)),r.handleOnClick=r.handleOnClick.bind(_assertThisInitialized(r)),r}return _inherits(t,e),_createClass(t,[{key:"handleOnClick",value:function(e){var t=this.props,r=t.carouselStore,i=t.onClick,n=t.slide,s=t.totalSlides,o=t.visibleSlides,a=n>=s-o?s-o:n;r.setStoreState({currentSlide:a},null!==i&&i.call(this,e))}},{key:"render",value:function(){var e=this.props,t=(e.carouselStore,e.children,e.className),r=e.currentSlide,i=e.disabled,n=(e.onClick,e.selected),s=e.slide,o=(e.totalSlides,e.visibleSlides),a=_objectWithoutProperties(e,["carouselStore","children","className","currentSlide","disabled","onClick","selected","slide","totalSlides","visibleSlides"]),l=s>=r&&s<r+o,c="boolean"==typeof n?n:l,u=!0===l,p="boolean"==typeof i?i:u,d=cn([s$5.dot,c&&s$5.dotSelected,"carousel__dot","carousel__dot--".concat(s),c&&"carousel__dot--selected",t]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",_extends({"aria-label":"slide dot",type:"button",onClick:this.handleOnClick,className:d,disabled:p},a),this.props.children)}}]),t}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component),_defineProperty(_class$5,"propTypes",{carouselStore:propTypes.object.isRequired,children:CarouselPropTypes.children.isRequired,className:propTypes.string,currentSlide:propTypes.number.isRequired,disabled:propTypes.bool,onClick:propTypes.func,selected:propTypes.bool,slide:propTypes.number.isRequired,totalSlides:propTypes.number.isRequired,visibleSlides:propTypes.number.isRequired}),_defineProperty(_class$5,"defaultProps",{className:null,disabled:null,onClick:null,selected:null}),_temp$5),Dot$1=WithStore(Dot,function(e){return{currentSlide:e.currentSlide,totalSlides:e.totalSlides,visibleSlides:e.visibleSlides}}),s$6={},_class$6,_temp$6,DotGroup=(_temp$6=_class$6=function(e){function t(){return _classCallCheck(this,t),_possibleConstructorReturn(this,_getPrototypeOf(t).apply(this,arguments))}return _inherits(t,e),_createClass(t,[{key:"renderDots",value:function(){var e=this.props,t=e.currentSlide,r=e.totalSlides,i=e.visibleSlides,n=e.disableActiveDots,s=e.showAsSelectedForCurrentSlideOnly,o=e.renderDots;if(o){var a=this.props;a.renderDots;return o(_objectWithoutProperties(a,["renderDots"]))}for(var l=[],c=0;c<r;c+=1){var u=c>=t&&c<t+i,p=c===t,d=s?p:u,h=c>=r-i?r-i:c;l.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Dot$1,{key:c,slide:h,selected:d,disabled:!!n&&d},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:cn["carousel__dot-group-dot"]},this.props.dotNumbers&&c+1)))}return l}},{key:"render",value:function(){var e=this.props,t=(e.carouselStore,e.children),r=e.className,i=(e.currentSlide,e.dotNumbers,e.totalSlides,e.visibleSlides,e.disableActiveDots,e.showAsSelectedForCurrentSlideOnly,e.renderDots,_objectWithoutProperties(e,["carouselStore","children","className","currentSlide","dotNumbers","totalSlides","visibleSlides","disableActiveDots","showAsSelectedForCurrentSlideOnly","renderDots"])),n=cn([s$6.DotGroup,"carousel__dot-group",r]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",_extends({className:n},i),this.renderDots(),t)}}]),t}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component),_defineProperty(_class$6,"propTypes",{children:CarouselPropTypes.children,className:propTypes.string,currentSlide:propTypes.number.isRequired,carouselStore:propTypes.object.isRequired,totalSlides:propTypes.number.isRequired,visibleSlides:propTypes.number.isRequired,dotNumbers:propTypes.bool,disableActiveDots:propTypes.bool,showAsSelectedForCurrentSlideOnly:propTypes.bool,renderDots:propTypes.func}),_defineProperty(_class$6,"defaultProps",{children:null,className:null,dotNumbers:!1,disableActiveDots:!0,showAsSelectedForCurrentSlideOnly:!1,renderDots:null}),_temp$6),index$5=WithStore(DotGroup,function(e){return{currentSlide:e.currentSlide,totalSlides:e.totalSlides,visibleSlides:e.visibleSlides}}),s$7={image:"image___xtQGH"},Image=function(e){function t(e){var r;return _classCallCheck(this,t),r=_possibleConstructorReturn(this,_getPrototypeOf(t).call(this,e)),r.state={imageStatus:LOADING},r.handleImageLoad=r.handleImageLoad.bind(_assertThisInitialized(r)),r.handleImageError=r.handleImageError.bind(_assertThisInitialized(r)),r.image=null,r}return _inherits(t,e),_createClass(t,null,[{key:"subscribeMasterSpinner",value:function(e){e.hasMasterSpinner&&e.carouselStore.subscribeMasterSpinner(e.src)}},{key:"unsubscribeMasterSpinner",value:function(e){e.hasMasterSpinner&&e.carouselStore.unsubscribeMasterSpinner(e.src)}}]),_createClass(t,[{key:"componentDidMount",value:function(){t.subscribeMasterSpinner(this.props),this.initImage()}},{key:"componentDidUpdate",value:function(e){e.src!==this.props.src&&(t.unsubscribeMasterSpinner(e),t.subscribeMasterSpinner(this.props),this.initImage())}},{key:"componentWillUnmount",value:function(){t.unsubscribeMasterSpinner(this.props),this.image.removeEventListener("load",this.handleImageLoad),this.image.removeEventListener("error",this.handleImageError),this.image=null}},{key:"initImage",value:function(){if(this.setState({imageStatus:LOADING}),this.image=document.createElement("img"),this.image.addEventListener("load",this.handleImageLoad,!1),this.image.addEventListener("error",this.handleImageError,!1),this.image.src=this.props.src,this.image.readyState||this.image.complete){var e=this.image.src;this.image.src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==",this.image.src=e}}},{key:"handleImageLoad",value:function(e){this.setState({imageStatus:SUCCESS}),this.props.hasMasterSpinner&&this.props.carouselStore.masterSpinnerSuccess(this.props.src),this.props.onLoad&&this.props.onLoad(e)}},{key:"handleImageError",value:function(e){this.setState({imageStatus:ERROR}),this.props.hasMasterSpinner&&this.props.carouselStore.masterSpinnerError(this.props.src),this.props.onError&&this.props.onError(e)}},{key:"tempTag",value:function(){return"img"===this.props.tag?"div":this.props.tag}},{key:"customRender",value:function(e){return"function"==typeof this.props[e]?this.props[e]():this.props.children}},{key:"renderLoading",value:function(e){var t=this.tempTag(),r=cn([s$7.image,s$7.imageLoading,"carousel__image",this.props.isBgImage&&"carousel__image--with-background","carousel__image--loading",this.props.className]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(t,_extends({className:r},e),this.customRender("renderLoading"))}},{key:"renderError",value:function(e){var t=this.tempTag(),r=cn([s$7.image,s$7.imageError,"carousel__image",this.props.isBgImage&&"carousel__image--with-background","carousel__image--error",this.props.className]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(t,_extends({className:r},e),this.customRender("renderError"))}},{key:"renderSuccess",value:function(e){var t=this.props,r=t.style,i=t.tag,n=cn([s$7.image,"carousel__image",this.props.isBgImage&&"carousel__image--with-background","carousel__image--success",this.props.className]),s=_extends({},r),o=e;if("img"!==i){var a=e.src;e.alt;o=_objectWithoutProperties(e,["src","alt"]),s=_extends({},r,{backgroundImage:'url("'.concat(a,'")'),backgroundSize:"cover"})}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(i,_extends({className:n,style:s},o),this.props.children)}},{key:"render",value:function(){var e=this.props,t=(e.carouselStore,e.children,e.className,e.hasMasterSpinner,e.isBgImage,e.onError,e.onLoad,e.renderError,e.renderLoading,e.style,e.tag,_objectWithoutProperties(e,["carouselStore","children","className","hasMasterSpinner","isBgImage","onError","onLoad","renderError","renderLoading","style","tag"]));switch(this.state.imageStatus){case LOADING:return this.renderLoading(t);case SUCCESS:return this.renderSuccess(t);case ERROR:return this.renderError(t);default:throw new Error("unknown value for this.state.imageStatus")}}}]),t}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);_defineProperty(Image,"propTypes",{alt:propTypes.string,carouselStore:propTypes.object.isRequired,children:CarouselPropTypes.children,className:propTypes.string,hasMasterSpinner:propTypes.bool.isRequired,isBgImage:CarouselPropTypes.isBgImage,onError:propTypes.func,onLoad:propTypes.func,renderError:propTypes.func,renderLoading:propTypes.func,src:propTypes.string.isRequired,style:propTypes.object,tag:propTypes.string}),_defineProperty(Image,"defaultProps",{alt:"",children:null,className:null,isBgImage:!1,onError:null,onLoad:null,renderError:null,renderLoading:null,style:null,tag:"img"});var Image$1=WithStore(Image,function(e){return{hasMasterSpinner:e.hasMasterSpinner,orientation:e.orientation}}),s$8={spinner:"spinner___27VUp",spin:"spin___S3UuE"},_class$7,_temp$7,Spinner=(_temp$7=_class$7=function(e){function t(){return _classCallCheck(this,t),_possibleConstructorReturn(this,_getPrototypeOf(t).apply(this,arguments))}return _inherits(t,e),_createClass(t,[{key:"render",value:function(){var e=this.props,t=e.className,r=_objectWithoutProperties(e,["className"]),i=cn([s$8.spinner,"carousel__spinner",t]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",_extends({className:i},r))}}]),t}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent),_defineProperty(_class$7,"propTypes",{className:propTypes.string}),_defineProperty(_class$7,"defaultProps",{className:null}),_temp$7),s$9={container:"container___2O72F",overlay:"overlay___IV4qY",hover:"hover___MYy31",zoom:"zoom___3kqYk",loading:"loading___1pvNI",imageLoadingSpinnerContainer:"imageLoadingSpinnerContainer___3UIPD"},_class$8,_temp$8,MOUSE_SCALE=2,MAX_TOUCH_SCALE=3,ImageWithZoom=(_temp$8=_class$8=function(e){function t(e){var r;return _classCallCheck(this,t),r=_possibleConstructorReturn(this,_getPrototypeOf(t).call(this,e)),r.state={isImageLoading:!0,isHovering:!1,isZooming:!1,x:null,y:null,scale:1},r.tpCache={},r.handleImageComplete=r.handleImageComplete.bind(_assertThisInitialized(r)),r.handleOnMouseMove=r.handleOnMouseMove.bind(_assertThisInitialized(r)),r.handleOnMouseOut=r.handleOnMouseOut.bind(_assertThisInitialized(r)),r.handleOnMouseOver=r.handleOnMouseOver.bind(_assertThisInitialized(r)),r.handleOnTouchEnd=r.handleOnTouchEnd.bind(_assertThisInitialized(r)),r.handleOnTouchMove=r.handleOnTouchMove.bind(_assertThisInitialized(r)),r.handleOnTouchStart=r.handleOnTouchStart.bind(_assertThisInitialized(r)),r}return _inherits(t,e),_createClass(t,null,[{key:"midpointBetweenTwoTouches",value:function(e){var t=e.x1,r=e.y1;return{x:(t+e.x2)/2,y:(r+e.y2)/2}}},{key:"distanceBetweenTwoTouches",value:function(e){var t=e.x1,r=e.y1,i=e.x2,n=e.y2;return Math.sqrt(Math.pow(i-t,2)+Math.pow(n-r,2))}}]),_createClass(t,[{key:"componentDidUpdate",value:function(e,t){!1===t.isZooming&&!0===this.state.isZooming&&this.props.carouselStore.setStoreState({isPageScrollLocked:!0}),!0===t.isZooming&&!1===this.state.isZooming&&this.props.carouselStore.setStoreState({isPageScrollLocked:!1})}},{key:"handleImageComplete",value:function(){this.setState({isImageLoading:!1})}},{key:"handleOnMouseOver",value:function(){this.state.isZooming||this.setState({isHovering:!0,scale:MOUSE_SCALE})}},{key:"handleOnMouseOut",value:function(){this.state.isZooming||this.setState({isHovering:!1,scale:1})}},{key:"handleOnMouseMove",value:function(e){if(!this.state.isZooming){var t=pct(e.nativeEvent.offsetX/e.target.offsetWidth*100),r=pct(e.nativeEvent.offsetY/e.target.offsetHeight*100);this.setState({x:t,y:r})}}},{key:"handleOnTouchStart",value:function(e){var t=this;this.props.isPinchZoomEnabled&&(_toConsumableArray(e.targetTouches).forEach(function(e){t.tpCache[e.identifier]={clientX:e.clientX,clientY:e.clientY}}),this.setState(function(e){return{isZooming:e.isZooming||Object.keys(t.tpCache).length>1}}))}},{key:"handleOnTouchMove",value:function(e){var r=this;if(this.state.isZooming){e.persist();var i=_toConsumableArray(e.targetTouches).filter(function(e){return r.tpCache[e.identifier]}).slice(0,2);if(2===i.length){e.stopPropagation();var n=e.target.getBoundingClientRect(),s=i[0].identifier,o=i[1].identifier,a={x1:this.tpCache[s].clientX,y1:this.tpCache[s].clientY,x2:this.tpCache[o].clientX,y2:this.tpCache[o].clientY};a.distance=t.distanceBetweenTwoTouches(_objectSpread2({},a));var l=t.midpointBetweenTwoTouches(_objectSpread2({},a));a.cx=l.x,a.cy=l.y;var c={x1:i[0].clientX,y1:i[0].clientY,x2:i[1].clientX,y2:i[1].clientY};c.distance=t.distanceBetweenTwoTouches(_objectSpread2({},c));var u=t.midpointBetweenTwoTouches(_objectSpread2({},c));c.cx=u.x,c.cy=u.y;var p=pct(boundedRange({min:0,max:100,x:(c.cx-n.left)/n.width*100})),d=pct(boundedRange({min:0,max:100,x:(c.cy-n.top)/n.height*100})),h=function(e){return boundedRange({min:1,max:MAX_TOUCH_SCALE,x:e.scale+(c.distance-a.distance)/100})};this.setState(function(e){return{isZooming:1!==h(e),scale:h(e),x:p,y:d}})}}}},{key:"handleOnTouchEnd",value:function(e){var t=this;this.props.isPinchZoomEnabled&&(_toConsumableArray(e.changedTouches).forEach(function(e){delete t.tpCache[e.identifier]}),0===Object.keys(this.tpCache).length&&this.setState({isZooming:!1}))}},{key:"renderLoading",value:function(){if(this.state.isImageLoading){var e=this.props.spinner;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:cn([s$9.imageLoadingSpinnerContainer,"carousel__image-loading-spinner-container"])},e&&e(),!e&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Spinner,null))}return null}},{key:"render",value:function(){var e=this.props,t=(e.carouselStore,e.isPinchZoomEnabled,e.spinner,e.src),r=e.srcZoomed,i=e.tag,n=_objectWithoutProperties(e,["carouselStore","isPinchZoomEnabled","spinner","src","srcZoomed","tag"]),s=cn([s$9.image,"carousel__zoom-image"]),o=cn([s$9.overlay,"carousel__zoom-image-overlay",this.state.isHovering&&s$9.hover,this.state.isZooming&&s$9.zoom,this.state.isHovering&&"carousel__zoom-image-overlay--hovering",this.state.isZooming&&"carousel__zoom-image-overlay--zooming"]),a={};return(this.state.isHovering||this.state.isZooming)&&(a.transformOrigin="".concat(this.state.x," ").concat(this.state.y),a.transform="scale(".concat(this.state.scale,")")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(i,_extends({className:s$9.container},n),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Image$1,{className:s,tag:"div",src:t,isBgImage:!0,onLoad:this.handleImageComplete,onError:this.handleImageComplete}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Image$1,{className:o,tag:"div",src:r||t,style:a,isBgImage:!0,onFocus:this.handleOnMouseOver,onMouseOver:this.handleOnMouseOver,onBlur:this.handleOnMouseOut,onMouseOut:this.handleOnMouseOut,onMouseMove:this.handleOnMouseMove,onTouchStart:this.handleOnTouchStart,onTouchEnd:this.handleOnTouchEnd,onTouchMove:this.handleOnTouchMove}),this.renderLoading())}}]),t}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component),_defineProperty(_class$8,"propTypes",{carouselStore:propTypes.object.isRequired,spinner:propTypes.func,src:propTypes.string.isRequired,srcZoomed:propTypes.string,tag:propTypes.string,isPinchZoomEnabled:propTypes.bool}),_defineProperty(_class$8,"defaultProps",{isPinchZoomEnabled:!0,spinner:null,srcZoomed:null,tag:"div"}),_temp$8),index$6=WithStore(ImageWithZoom,function(){return{}}),s$a={slide:"slide___3-Nqo",slideHorizontal:"slideHorizontal___1NzNV",slideInner:"slideInner___2mfX9",focusRing:"focusRing___1airF"},_class$9,_temp$9,Slide=(_temp$9=_class$9=function(e){function t(e){var r;return _classCallCheck(this,t),r=_possibleConstructorReturn(this,_getPrototypeOf(t).call(this,e)),r.handleOnFocus=r.handleOnFocus.bind(_assertThisInitialized(r)),r.handleOnBlur=r.handleOnBlur.bind(_assertThisInitialized(r)),r.state={focused:!1},r}return _inherits(t,e),_createClass(t,[{key:"isVisible",value:function(){var e=this.props,t=e.currentSlide,r=e.index,i=e.visibleSlides;return r>=t&&r<t+i}},{key:"handleOnFocus",value:function(e){var t=this,r=this.props.onFocus;this.setState({focused:!0},function(){null!==r&&r.call(t,e)})}},{key:"handleOnBlur",value:function(e){var t=this,r=this.props.onBlur;this.setState({focused:!1},function(){null!==r&&r.call(t,e)})}},{key:"renderFocusRing",value:function(){return this.state.focused?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:[s$a.focusRing,"carousel__slide-focus-ring"].join(" ")}):null}},{key:"render",value:function(){var e=this,t=this.props,r=(t.carouselStore,t.children,t.className),i=t.classNameHidden,n=t.classNameVisible,s=(t.currentSlide,t.index,t.innerClassName),o=t.innerTag,a=t.naturalSlideHeight,l=t.naturalSlideWidth,c=(t.onBlur,t.onFocus,t.orientation),u=t.slideSize,p=t.style,d=t.tabIndex,h=t.tag,S=t.totalSlides,y=(t.visibleSlides,_objectWithoutProperties(t,["carouselStore","children","className","classNameHidden","classNameVisible","currentSlide","index","innerClassName","innerTag","naturalSlideHeight","naturalSlideWidth","onBlur","onFocus","orientation","slideSize","style","tabIndex","tag","totalSlides","visibleSlides"])),b={};"horizontal"===c?(b.width=pct(u),b.paddingBottom=pct(100*a/(l*S))):(b.width=pct(100),b.paddingBottom=pct(100*a/l));var m=_extends({},b,p),f=this.isVisible(),g=cn([s$a.slide,"horizontal"===c&&s$a.slideHorizontal,"carousel__slide",this.state.focused&&"carousel__slide--focused",f&&n,f&&"carousel__slide--visible",!f&&i,!f&&"carousel__slide--hidden",r]),v=cn([s$a.slideInner,"carousel__inner-slide",s]),_=this.isVisible()?0:-1,T="number"==typeof d?d:_;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(h,_extends({ref:function(t){e.tagRef=t},tabIndex:T,"aria-selected":this.isVisible(),role:"option",onFocus:this.handleOnFocus,onBlur:this.handleOnBlur,className:g,style:m},y),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(o,{ref:function(t){e.innerTagRef=t},className:v},this.props.children,this.renderFocusRing()))}}]),t}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent),_defineProperty(_class$9,"propTypes",{carouselStore:propTypes.object,children:CarouselPropTypes.children,className:propTypes.string,classNameHidden:propTypes.string,classNameVisible:propTypes.string,currentSlide:propTypes.number.isRequired,index:propTypes.number.isRequired,innerClassName:propTypes.string,innerTag:propTypes.string,naturalSlideHeight:propTypes.number.isRequired,naturalSlideWidth:propTypes.number.isRequired,onBlur:propTypes.func,onFocus:propTypes.func,orientation:CarouselPropTypes.orientation.isRequired,slideSize:propTypes.number.isRequired,style:propTypes.object,tabIndex:propTypes.number,tag:propTypes.string,totalSlides:propTypes.number.isRequired,visibleSlides:propTypes.number.isRequired}),_defineProperty(_class$9,"defaultProps",{carouselStore:null,children:null,className:null,classNameHidden:null,classNameVisible:null,innerClassName:null,innerTag:"div",onBlur:null,onFocus:null,style:{},tabIndex:null,tag:"li"}),_temp$9),index$7=WithStore(Slide,function(e){return{currentSlide:e.currentSlide,naturalSlideHeight:e.naturalSlideHeight,naturalSlideWidth:e.naturalSlideWidth,orientation:e.orientation,slideSize:e.slideSize,totalSlides:e.totalSlides,visibleSlides:e.visibleSlides}}),GetScrollParent=function(){function e(){_classCallCheck(this,e)}return _createClass(e,[{key:"parents",value:function(e,t){return null===e.parentNode?t:this.parents(e.parentNode,t.concat([e]))}},{key:"scrollParent",value:function(t){for(var r=this.parents(t.parentNode,[]),i=0;i<r.length;i+=1)if(e.scroll(r[i]))return r[i];return document.scrollingElement||document.documentElement}},{key:"getScrollParent",value:function(t){return e.isNodeValid(t)?this.scrollParent(t):null}}],[{key:"style",value:function(e,t){return getComputedStyle(e,null).getPropertyValue(t)}},{key:"overflow",value:function(t){return e.style(t,"overflow")+e.style(t,"overflow-y")+e.style(t,"overflow-x")}},{key:"scroll",value:function(t){return/(auto|scroll)/.test(e.overflow(t))}},{key:"isNodeValid",value:function(e){return e instanceof HTMLElement||e instanceof SVGElement}}]),e}(),s$b={horizontalSlider:"horizontalSlider___281Ls",horizontalSliderTray:"horizontalSliderTray___1L-0W",verticalSlider:"verticalSlider___34ZFD",verticalSliderTray:"verticalSliderTray___267D8",verticalTray:"verticalTray___12Key",verticalSlideTrayWrap:"verticalSlideTrayWrap___2nO7o",sliderTray:"sliderTray___-vHFQ",sliderAnimation:"sliderAnimation___300FY",masterSpinnerContainer:"masterSpinnerContainer___1Z6hB"},_class$a,_temp$a,Slider=(_temp$a=_class$a=function(e){function t(e){var r;return _classCallCheck(this,t),r=_possibleConstructorReturn(this,_getPrototypeOf(t).call(this,e)),r.getSliderRef=r.getSliderRef.bind(_assertThisInitialized(r)),r.handleDocumentScroll=r.handleDocumentScroll.bind(_assertThisInitialized(r)),r.handleOnClickCapture=r.handleOnClickCapture.bind(_assertThisInitialized(r)),r.handleOnKeyDown=r.handleOnKeyDown.bind(_assertThisInitialized(r)),r.handleOnMouseDown=r.handleOnMouseDown.bind(_assertThisInitialized(r)),r.handleOnMouseMove=r.handleOnMouseMove.bind(_assertThisInitialized(r)),r.handleOnMouseUp=r.handleOnMouseUp.bind(_assertThisInitialized(r)),r.handleOnTouchCancel=r.handleOnTouchCancel.bind(_assertThisInitialized(r)),r.handleOnTouchEnd=r.handleOnTouchEnd.bind(_assertThisInitialized(r)),r.handleOnTouchMove=r.handleOnTouchMove.bind(_assertThisInitialized(r)),r.handleOnTouchStart=r.handleOnTouchStart.bind(_assertThisInitialized(r)),r.playBackward=r.playBackward.bind(_assertThisInitialized(r)),r.playForward=r.playForward.bind(_assertThisInitialized(r)),r.callCallback=r.callCallback.bind(_assertThisInitialized(r)),r.state={cancelNextClick:!1,deltaX:0,deltaY:0,isBeingMouseDragged:!1,isBeingTouchDragged:!1,startX:0,startY:0},r.interval=null,r.isDocumentScrolling=null,r.moveTimer=null,r.originalOverflow=null,r.scrollParent=null,r.scrollStopTimer=null,r}return _inherits(t,e),_createClass(t,null,[{key:"slideSizeInPx",value:function(e,t,r,i){return("horizontal"===e?t:r)/i}},{key:"slidesMoved",value:function(e,t,r,i,n,s){var o="horizontal"===t?r:i,a=Math.abs(Math.round(o/n)),l=Math.abs(o)>=n*e?s:0,c=Math.max(l,a);if(o<0)return c;var u=-c;return 0===u?0:u}}]),_createClass(t,[{key:"componentDidMount",value:function(){this.props.lockOnWindowScroll&&window.addEventListener("scroll",this.handleDocumentScroll,!1),document.documentElement.addEventListener("mouseleave",this.handleOnMouseUp,!1),document.documentElement.addEventListener("mousemove",this.handleOnMouseMove,!1),document.documentElement.addEventListener("mouseup",this.handleOnMouseUp,!1),this.props.isPlaying&&this.play()}},{key:"componentDidUpdate",value:function(e){!e.isPlaying&&this.props.isPlaying&&this.play(),e.isPlaying&&!this.props.isPlaying&&this.stop(),!e.isPageScrollLocked&&this.props.isPageScrollLocked&&this.lockScroll(),e.isPageScrollLocked&&!this.props.isPageScrollLocked&&this.unlockScroll(),!1===e.privateUnDisableAnimation&&!0===this.props.privateUnDisableAnimation&&this.props.carouselStore.setStoreState({privateUnDisableAnimation:!1,disableAnimation:!1})}},{key:"componentWillUnmount",value:function(){document.documentElement.removeEventListener("mouseleave",this.handleOnMouseUp,!1),document.documentElement.removeEventListener("mousemove",this.handleOnMouseMove,!1),document.documentElement.removeEventListener("mouseup",this.handleOnMouseUp,!1),window.removeEventListener("scroll",this.handleDocumentScroll,!1),this.stop(),window.cancelAnimationFrame.call(window,this.moveTimer),window.clearTimeout(this.scrollStopTimer),this.isDocumentScrolling=null,this.moveTimer=null,this.scrollStopTimer=null}},{key:"getSliderRef",value:function(e){this.sliderTrayElement=e}},{key:"fakeOnDragStart",value:function(e){var t=e.screenX,r=e.screenY,i=e.touchDrag,n=void 0!==i&&i,s=e.mouseDrag,o=void 0!==s&&s;this.props.carouselStore.setStoreState({isPlaying:!1}),window.cancelAnimationFrame.call(window,this.moveTimer),"vertical"===this.props.orientation&&this.props.carouselStore.setStoreState({isPageScrollLocked:!0}),this.setState({isBeingTouchDragged:n,isBeingMouseDragged:o,startX:t,startY:r})}},{key:"fakeOnDragMove",value:function(e,t){var r=this;this.moveTimer=window.requestAnimationFrame.call(window,function(){r.setState(function(r){return{deltaX:e-r.startX,deltaY:t-r.startY}})})}},{key:"fakeOnDragEnd",value:function(){window.cancelAnimationFrame.call(window,this.moveTimer),this.computeCurrentSlide(),"vertical"===this.props.orientation&&this.props.carouselStore.setStoreState({isPageScrollLocked:!1}),this.setState({deltaX:0,deltaY:0,isBeingTouchDragged:!1,isBeingMouseDragged:!1}),this.isDocumentScrolling=!this.props.lockOnWindowScroll&&null}},{key:"callCallback",value:function(e,t){var r=this.props.trayProps;r&&"function"==typeof r[e]&&(t.persist(),r[e](t))}},{key:"handleOnMouseDown",value:function(e){if(!this.props.dragEnabled)return void this.callCallback("onMouseDown",e);e.preventDefault(),this.fakeOnDragStart({screenX:e.screenX,screenY:e.screenY,mouseDrag:!0}),this.callCallback("onMouseDown",e)}},{key:"handleOnMouseMove",value:function(e){this.state.isBeingMouseDragged&&(this.setState({cancelNextClick:!0}),e.preventDefault(),this.fakeOnDragMove(e.screenX,e.screenY))}},{key:"handleOnMouseUp",value:function(e){this.state.isBeingMouseDragged&&(e.preventDefault(),this.fakeOnDragEnd())}},{key:"handleOnClickCapture",value:function(e){if(!this.state.cancelNextClick)return void this.callCallback("onClickCapture",e);e.preventDefault(),this.setState({cancelNextClick:!1}),this.callCallback("onClickCapture",e)}},{key:"handleOnTouchStart",value:function(e){if(!this.props.touchEnabled)return void this.callCallback("onTouchStart",e);"vertical"===this.props.orientation&&e.preventDefault();var t=e.targetTouches[0];this.fakeOnDragStart({screenX:t.screenX,screenY:t.screenY,touchDrag:!0}),this.callCallback("onTouchStart",e)}},{key:"handleDocumentScroll",value:function(){var e=this;this.props.touchEnabled&&(this.isDocumentScrolling=!0,window.clearTimeout(this.scrollStopTimer),this.scrollStopTimer=window.setTimeout(function(){e.isDocumentScrolling=!1},66))}},{key:"handleOnTouchMove",value:function(e){if(!this.props.touchEnabled||this.props.lockOnWindowScroll&&this.isDocumentScrolling)return void this.callCallback("onTouchMove",e);window.cancelAnimationFrame.call(window,this.moveTimer);var t=e.targetTouches[0];t&&(this.fakeOnDragMove(t.screenX,t.screenY),this.callCallback("onTouchMove",e))}},{key:"forward",value:function(){var e=this.props,t=e.currentSlide,r=e.step,i=e.totalSlides,n=e.visibleSlides;return Math.min(t+r,i-n)}},{key:"backward",value:function(){var e=this.props,t=e.currentSlide,r=e.step;return Math.max(t-r,0)}},{key:"handleOnKeyDown",value:function(e){var t=e.keyCode,r=this.props,i=r.carouselStore,n=r.currentSlide,s=r.disableKeyboard,o=r.totalSlides,a=r.visibleSlides,l={};!0===s||o<=a||(37===t&&(e.preventDefault(),this.focus(),l.currentSlide=Math.max(0,n-1),l.isPlaying=!1),39===t&&(e.preventDefault(),this.focus(),l.currentSlide=Math.min(o-a,n+1),l.isPlaying=!1),i.setStoreState(l))}},{key:"playForward",value:function(){var e=this.props,t=e.carouselStore,r=e.currentSlide;t.setStoreState({currentSlide:this.forward()===r?0:this.forward()})}},{key:"playBackward",value:function(){var e=this.props,t=e.carouselStore,r=e.currentSlide,i=e.totalSlides,n=e.visibleSlides;t.setStoreState({currentSlide:this.backward()===r?i-n:this.backward()})}},{key:"play",value:function(){var e=this.props.playDirection;this.interval=setInterval("forward"===e?this.playForward:this.playBackward,this.props.interval)}},{key:"stop",value:function(){window.clearInterval(this.interval),this.interval=null}},{key:"lockScroll",value:function(){var e=new GetScrollParent;this.scrollParent=e.getScrollParent(this.sliderTrayElement),this.scrollParent&&(this.originalOverflow=this.originalOverflow||this.scrollParent.style.overflow,this.scrollParent.style.overflow="hidden")}},{key:"unlockScroll",value:function(){this.scrollParent&&(this.scrollParent.style.overflow=this.originalOverflow,this.originalOverflow=null,this.scrollParent=null)}},{key:"computeCurrentSlide",value:function(){var e=t.slideSizeInPx(this.props.orientation,this.sliderTrayElement.clientWidth,this.sliderTrayElement.clientHeight,this.props.totalSlides),r=t.slidesMoved(this.props.moveThreshold,this.props.orientation,this.state.deltaX,this.state.deltaY,e,this.props.dragStep),i=this.props.totalSlides-Math.min(this.props.totalSlides,this.props.visibleSlides),n=boundedRange({min:0,max:i,x:this.props.currentSlide+r});this.props.infinite&&(this.props.currentSlide>=i&&r>0&&(n=0),0===this.props.currentSlide&&r<0&&(n=i)),this.props.carouselStore.setStoreState({currentSlide:n})}},{key:"focus",value:function(){this.sliderElement.focus()}},{key:"handleOnTouchEnd",value:function(e){this.endTouchMove(),this.callCallback("onTouchEnd",e)}},{key:"handleOnTouchCancel",value:function(e){this.endTouchMove(),this.callCallback("onTouchCancel",e)}},{key:"endTouchMove",value:function(){this.props.touchEnabled&&this.fakeOnDragEnd()}},{key:"renderMasterSpinner",value:function(){var e=this.props,t=e.hasMasterSpinner,r=e.masterSpinnerFinished,i=e.spinner;return t&&!r?("function"==typeof this.props.onMasterSpinner&&this.props.onMasterSpinner(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:cn([s$b.masterSpinnerContainer,"carousel__master-spinner-container"])},i&&i(),!i&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Spinner,null))):null}},{key:"render",value:function(){var e=this,t=this.props,r=(t.carouselStore,t.children),i=t.className,n=t.classNameAnimation,s=t.classNameTray,o=t.classNameTrayWrap,a=t.currentSlide,l=t.disableAnimation,c=(t.disableKeyboard,t.dragEnabled,t.hasMasterSpinner,t.interval,t.isPageScrollLocked,t.isPlaying,t.lockOnWindowScroll,t.masterSpinnerFinished,t.moveThreshold,t.naturalSlideHeight),u=t.naturalSlideWidth,p=(t.onMasterSpinner,t.orientation),d=(t.playDirection,t.privateUnDisableAnimation,t.slideSize),h=t.slideTraySize,S=(t.spinner,t.style),y=t.tabIndex,b=(t.totalSlides,t.touchEnabled,t.trayProps),m=t.trayTag,f=t.visibleSlides,g=_objectWithoutProperties(t,["carouselStore","children","className","classNameAnimation","classNameTray","classNameTrayWrap","currentSlide","disableAnimation","disableKeyboard","dragEnabled","hasMasterSpinner","interval","isPageScrollLocked","isPlaying","lockOnWindowScroll","masterSpinnerFinished","moveThreshold","naturalSlideHeight","naturalSlideWidth","onMasterSpinner","orientation","playDirection","privateUnDisableAnimation","slideSize","slideTraySize","spinner","style","tabIndex","totalSlides","touchEnabled","trayProps","trayTag","visibleSlides"]),v=_extends({},S),_={};"vertical"===p&&(_.height=0,_.paddingBottom=pct(100*c*f/u),_.width=pct(100));var T={},k=pct(d*a*-1);(this.state.isBeingTouchDragged||this.state.isBeingMouseDragged||l)&&(T.transition="none"),"vertical"===p?(T.transform="translateY(".concat(k,") translateY(").concat(this.state.deltaY,"px)"),T.width=pct(100)):(T.width=pct(h),T.transform="translateX(".concat(k,") translateX(").concat(this.state.deltaX,"px)"));var C=cn(["vertical"===p?s$b.verticalSlider:s$b.horizontalSlider,"carousel__slider","vertical"===p?"carousel__slider--vertical":"carousel__slider--horizontal",i]),O=cn([s$b.sliderTrayWrap,"carousel__slider-tray-wrapper","vertical"===p?s$b.verticalSlideTrayWrap:s$b.horizontalTrayWrap,"vertical"===p?"carousel__slider-tray-wrap--vertical":"carousel__slider-tray-wrap--horizontal",o]),P=cn([s$b.sliderTray,n||s$b.sliderAnimation,"carousel__slider-tray","vertical"===p?s$b.verticalTray:s$b.horizontalTray,"vertical"===p?"carousel__slider-tray--vertical":"carousel__slider-tray--horizontal",s]),E=null!==y?y:0,M=(g.dragStep,g.step,g.infinite,_objectWithoutProperties(g,["dragStep","step","infinite"])),w=(b.className,b.onClickCapture,b.onMouseDown,b.onTouchCancel,b.onTouchEnd,b.onTouchMove,b.onTouchStart,b.ref,b.style,_objectWithoutProperties(b,["className","onClickCapture","onMouseDown","onTouchCancel","onTouchEnd","onTouchMove","onTouchStart","ref","style"]));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",_extends({ref:function(t){e.sliderElement=t},className:C,"aria-live":"polite",style:v,tabIndex:E,onKeyDown:this.handleOnKeyDown,role:"listbox"},M),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:O,style:_},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(m,_extends({ref:this.getSliderRef,className:P,style:T,onTouchStart:this.handleOnTouchStart,onTouchMove:this.handleOnTouchMove,onTouchEnd:this.handleOnTouchEnd,onTouchCancel:this.handleOnTouchCancel,onMouseDown:this.handleOnMouseDown,onClickCapture:this.handleOnClickCapture},w),r),this.renderMasterSpinner()))}}]),t}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component),_defineProperty(_class$a,"propTypes",{carouselStore:propTypes.object.isRequired,children:propTypes.node.isRequired,className:propTypes.string,classNameAnimation:propTypes.string,classNameTray:propTypes.string,classNameTrayWrap:propTypes.string,currentSlide:propTypes.number.isRequired,disableAnimation:propTypes.bool,disableKeyboard:propTypes.bool,dragEnabled:propTypes.bool.isRequired,dragStep:propTypes.number,hasMasterSpinner:propTypes.bool.isRequired,infinite:propTypes.bool,interval:propTypes.number.isRequired,isPageScrollLocked:propTypes.bool.isRequired,isPlaying:propTypes.bool.isRequired,lockOnWindowScroll:propTypes.bool.isRequired,masterSpinnerFinished:propTypes.bool.isRequired,moveThreshold:propTypes.number,naturalSlideHeight:propTypes.number.isRequired,naturalSlideWidth:propTypes.number.isRequired,onMasterSpinner:propTypes.func,orientation:CarouselPropTypes.orientation.isRequired,playDirection:CarouselPropTypes.direction.isRequired,privateUnDisableAnimation:propTypes.bool,slideSize:propTypes.number.isRequired,slideTraySize:propTypes.number.isRequired,spinner:propTypes.func,step:propTypes.number.isRequired,style:propTypes.object,tabIndex:propTypes.number,totalSlides:propTypes.number.isRequired,touchEnabled:propTypes.bool.isRequired,trayProps:propTypes.shape({className:propTypes.string,onClickCapture:propTypes.func,onMouseDown:propTypes.func,onTouchCancel:propTypes.func,onTouchEnd:propTypes.func,onTouchMove:propTypes.func,onTouchStart:propTypes.func,ref:propTypes.shape({}),style:propTypes.string}),trayTag:propTypes.string,visibleSlides:propTypes.number}),_defineProperty(_class$a,"defaultProps",{className:null,classNameAnimation:null,classNameTray:null,classNameTrayWrap:null,disableAnimation:!1,disableKeyboard:!1,dragStep:1,infinite:!1,moveThreshold:.1,onMasterSpinner:null,privateUnDisableAnimation:!1,spinner:null,style:{},tabIndex:null,trayProps:{},trayTag:"ul",visibleSlides:1}),_temp$a),index$8=WithStore(Slider,function(e){return{currentSlide:e.currentSlide,disableAnimation:e.disableAnimation,privateUnDisableAnimation:e.privateUnDisableAnimation,disableKeyboard:e.disableKeyboard,dragEnabled:e.dragEnabled,hasMasterSpinner:e.hasMasterSpinner,infinite:e.infinite,interval:e.interval,isPageScrollLocked:e.isPageScrollLocked,isPlaying:e.isPlaying,lockOnWindowScroll:e.lockOnWindowScroll,masterSpinnerFinished:e.masterSpinnerFinished,naturalSlideHeight:e.naturalSlideHeight,naturalSlideWidth:e.naturalSlideWidth,orientation:e.orientation,playDirection:e.playDirection,slideSize:e.slideSize,slideTraySize:e.slideTraySize,step:e.step,dragStep:e.dragStep,totalSlides:e.totalSlides,touchEnabled:e.touchEnabled,visibleSlides:e.visibleSlides}});
//# sourceMappingURL=index.es.js.map


/***/ }),

/***/ 236:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 237:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpecialtyPanel = exports.SpecialtyWrapper = undefined;

var _templateObject = _taggedTemplateLiteral(['\n    max-width: 100%;\n    display: flex;\n    justify-content: space-between;\n  '], ['\n    max-width: 100%;\n    display: flex;\n    justify-content: space-between;\n  ']),
    _templateObject2 = _taggedTemplateLiteral(['\n    position: sticky;\n    top: 0;\n    left: 0;\n\n    display: flex;\n    flex-direction: column;\n\n    height: 100vh;\n    width: 38%;\n    overflow: hidden;\n\n    .specItem {\n      flex-grow: 1;\n      flex-shrink: 1;\n      flex-basis: auto;\n      justify-content: center;\n\n      &.grows {\n        display: flex;\n        flex-grow: 20;\n        align-items: center;\n      }\n    }\n  '], ['\n    position: sticky;\n    top: 0;\n    left: 0;\n\n    display: flex;\n    flex-direction: column;\n\n    height: 100vh;\n    width: 38%;\n    overflow: hidden;\n\n    .specItem {\n      flex-grow: 1;\n      flex-shrink: 1;\n      flex-basis: auto;\n      justify-content: center;\n\n      &.grows {\n        display: flex;\n        flex-grow: 20;\n        align-items: center;\n      }\n    }\n  ']),
    _templateObject3 = _taggedTemplateLiteral(['\n    position: sticky;\n    top: 0;\n\n    height: 100vh;\n    width: 38%;\n    overflow: hidden;\n    left: 0;\n    display: flex;\n    flex-direction: column;\n\n    .specItem {\n      flex-grow: 1;\n      flex-shrink: 1;\n      flex-basis: auto;\n      justify-content: center;\n\n      &.grows {\n        display: flex;\n        flex-grow: 20;\n        align-items: center;\n      }\n    }\n  '], ['\n    position: sticky;\n    top: 0;\n\n    height: 100vh;\n    width: 38%;\n    overflow: hidden;\n    left: 0;\n    display: flex;\n    flex-direction: column;\n\n    .specItem {\n      flex-grow: 1;\n      flex-shrink: 1;\n      flex-basis: auto;\n      justify-content: center;\n\n      &.grows {\n        display: flex;\n        flex-grow: 20;\n        align-items: center;\n      }\n    }\n  ']),
    _templateObject4 = _taggedTemplateLiteral(['\n    font-size: 7.2vw;\n    margin-top: -3px;\n\n    @media screen and (orientation:landscape) {\n      margin-top: -5px;\n    }\n  '], ['\n    font-size: 7.2vw;\n    margin-top: -3px;\n\n    @media screen and (orientation:landscape) {\n      margin-top: -5px;\n    }\n  ']),
    _templateObject5 = _taggedTemplateLiteral(['\n    position: initial;\n    top: initial;\n\n    //font-size: 96px;\n    //line-height: 78px;\n    font-size: 7.3vw;\n    margin-top: -8px;\n  '], ['\n    position: initial;\n    top: initial;\n\n    //font-size: 96px;\n    //line-height: 78px;\n    font-size: 7.3vw;\n    margin-top: -8px;\n  ']),
    _templateObject6 = _taggedTemplateLiteral(['\n    font-size: 2vh;\n    padding: 0 2rem;\n\n    @media screen and (orientation:landscape) {\n      font-size: 2.4vh;\n    }\n  '], ['\n    font-size: 2vh;\n    padding: 0 2rem;\n\n    @media screen and (orientation:landscape) {\n      font-size: 2.4vh;\n    }\n  ']),
    _templateObject7 = _taggedTemplateLiteral(['\n    font-size: 2.8vh;\n    padding: 0 8vh;\n    line-height: 4vh;\n  '], ['\n    font-size: 2.8vh;\n    padding: 0 8vh;\n    line-height: 4vh;\n  ']),
    _templateObject8 = _taggedTemplateLiteral(['\n    padding: 0 2rem;\n  '], ['\n    padding: 0 2rem;\n  ']),
    _templateObject9 = _taggedTemplateLiteral(['\n    padding: 0 8vh;\n  '], ['\n    padding: 0 8vh;\n  ']),
    _templateObject10 = _taggedTemplateLiteral(['\n    max-width: 62%;\n  '], ['\n    max-width: 62%;\n  ']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _styledComponents = __webpack_require__(13);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _styledComponentsBreakpoint = __webpack_require__(45);

var _styledComponentsBreakpoint2 = _interopRequireDefault(_styledComponentsBreakpoint);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var SpecialtyWrapper = exports.SpecialtyWrapper = _styledComponents2.default.div.withConfig({
  displayName: 'Specialty__SpecialtyWrapper',
  componentId: 'pq5osx-0'
})(['position:relative;background:#EDEBEB;', ' ', ''], (0, _styledComponentsBreakpoint2.default)('desktop')(_templateObject), (0, _styledComponentsBreakpoint2.default)('tablet')(_templateObject));

var SpecialtyPanel = exports.SpecialtyPanel = _styledComponents2.default.div.withConfig({
  displayName: 'Specialty__SpecialtyPanel',
  componentId: 'pq5osx-1'
})(['background:', ';overflow:hidden;', ' ', ' .specialtyHeading{}'], function (props) {
  return props.bg;
}, (0, _styledComponentsBreakpoint2.default)('desktop')(_templateObject2), (0, _styledComponentsBreakpoint2.default)('tablet')(_templateObject3));

var Heading = _styledComponents2.default.h2.withConfig({
  displayName: 'Specialty__Heading',
  componentId: 'pq5osx-2'
})(['margin:0;font-family:\'Exo 2\',sans-serif;font-style:normal;font-weight:700;font-size:19.4vw;line-height:0.75;text-transform:uppercase;color:rgba(255,255,255,0.2);margin-top:-5px;', ' ', ''], (0, _styledComponentsBreakpoint2.default)('tablet')(_templateObject4), (0, _styledComponentsBreakpoint2.default)('desktop')(_templateObject5));

var Description = _styledComponents2.default.p.withConfig({
  displayName: 'Specialty__Description',
  componentId: 'pq5osx-3'
})(['font-family:"Roboto",Helvetica,Arial,sans-serif;font-style:normal;font-weight:400;line-height:1.6rem;font-size:1.2rem;color:rgba(255,255,255,0.8);padding:3rem 1rem;', ' ', ''], (0, _styledComponentsBreakpoint2.default)('tablet')(_templateObject6), (0, _styledComponentsBreakpoint2.default)('desktop')(_templateObject7));

var Team = _styledComponents2.default.p.withConfig({
  displayName: 'Specialty__Team',
  componentId: 'pq5osx-4'
})(['font-family:"Roboto",Helvetica,Arial,sans-serif;font-style:normal;font-weight:400;line-height:1.4;font-size:1rem;color:rgba(255,255,255,0.5);padding:0 1rem;', ' ', ''], (0, _styledComponentsBreakpoint2.default)('tablet')(_templateObject8), (0, _styledComponentsBreakpoint2.default)('desktop')(_templateObject9));

var ProjectsWrapper = _styledComponents2.default.div.withConfig({
  displayName: 'Specialty__ProjectsWrapper',
  componentId: 'pq5osx-5'
})(['', ' ', ''], (0, _styledComponentsBreakpoint2.default)('tablet')(_templateObject10), (0, _styledComponentsBreakpoint2.default)('desktop')(_templateObject10));

var SpecialtyBg = ['#F3A712', '#E6212B', '#00B2CB', '#12161E', '#C700CB'];

exports.default = function (_ref) {
  var children = _ref.children,
      props = _ref.props,
      bgIdx = _ref.bgIdx;
  return _react2.default.createElement(
    SpecialtyWrapper,
    null,
    _react2.default.createElement(
      SpecialtyPanel,
      { bg: SpecialtyBg[bgIdx] },
      _react2.default.createElement(
        Heading,
        { className: 'specItem' },
        props.title,
        ' '
      ),
      _react2.default.createElement(
        'div',
        { className: 'specItem grows' },
        _react2.default.createElement(
          Description,
          null,
          props.description,
          ' '
        )
      ),
      _react2.default.createElement(
        Team,
        { className: 'specItem' },
        props.people,
        ' '
      )
    ),
    _react2.default.createElement(
      ProjectsWrapper,
      null,
      children
    )
  );
};

/***/ }),

/***/ 238:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n    display: flex;\n    align-items: center;\n    min-height: 100vh;\n  '], ['\n    display: flex;\n    align-items: center;\n    min-height: 100vh;\n  ']),
    _templateObject2 = _taggedTemplateLiteral(['\n    padding: 0 5rem;\n  '], ['\n    padding: 0 5rem;\n  ']),
    _templateObject3 = _taggedTemplateLiteral(['\n    //padding: 0 15rem;\n    padding: 0 24vmin;\n  '], ['\n    //padding: 0 15rem;\n    padding: 0 24vmin;\n  ']);

var _styledSystem = __webpack_require__(157);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _styledComponentsBreakpoint = __webpack_require__(45);

var _styledComponentsBreakpoint2 = _interopRequireDefault(_styledComponentsBreakpoint);

var _styledComponents = __webpack_require__(13);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Project = _styledComponents2.default.div.withConfig({
  displayName: 'Project',
  componentId: 'd9zx3a-0'
})(['', ' ', ''], (0, _styledComponentsBreakpoint2.default)('tablet')(_templateObject), (0, _styledComponentsBreakpoint2.default)('desktop')(_templateObject));

var ProjectContent = _styledComponents2.default.section.withConfig({
  displayName: 'Project__ProjectContent',
  componentId: 'd9zx3a-1'
})(['display:inline-block;padding:0 1rem;', ' ', ''], (0, _styledComponentsBreakpoint2.default)('tablet')(_templateObject2), (0, _styledComponentsBreakpoint2.default)('desktop')(_templateObject3));

var Heading = _styledComponents2.default.h3.withConfig({
  displayName: 'Project__Heading',
  componentId: 'd9zx3a-2'
})(['', ' ', ' ', ' letter-spacing:0.03em;text-transform:uppercase;'], _styledSystem.typography, _styledSystem.color, _styledSystem.space);
Heading.defaultProps = {
  mt: 2,
  mb: 1,
  p: 0,
  fontFamily: 'title',
  fontSize: 4,
  fontWeight: 'titleSemi',
  lineHeight: 'copy',
  color: 'highContrast'
};

var Text = _styledComponents2.default.p.withConfig({
  displayName: 'Project__Text',
  componentId: 'd9zx3a-3'
})(['', ' ', ' ', ' letter-spacing:0.03em;'], _styledSystem.typography, _styledSystem.color, _styledSystem.space);
Text.defaultProps = {
  fontFamily: 'body',
  fontSize: 3,
  fontWeight: 'bodyMedium',
  lineHeight: 'small',
  color: 'highContrast'
};

var BibList = _styledComponents2.default.ul.withConfig({
  displayName: 'Project__BibList',
  componentId: 'd9zx3a-4'
})(['margin-top:3rem;padding-left:0;']);

var BibItem = _styledComponents2.default.li.withConfig({
  displayName: 'Project__BibItem',
  componentId: 'd9zx3a-5'
})(['', ' padding:0.5rem;list-style:none;letter-spacing:0.03em;color:#828282;&:hover{background-color:#e0dcdc;transition:background-color 0.2s cubic-bezier(0.25,0.46,0.45,0.94);}'], _styledSystem.typography);
BibItem.defaultProps = {
  lineHeight: 'tiny'
};

var BibLink = _styledComponents2.default.a.withConfig({
  displayName: 'Project__BibLink',
  componentId: 'd9zx3a-6'
})(['', ' ', ' font-style:italic;'], _styledSystem.typography, _styledSystem.color);
BibLink.defaultProps = {
  fontFamily: 'body',
  fontSize: 1,
  fontWeight: 'bodyMedium',
  lineHeight: 'tiny',
  color: 'midContrast'
};

var BibAuthors = _styledComponents2.default.span.withConfig({
  displayName: 'Project__BibAuthors',
  componentId: 'd9zx3a-7'
})(['font-style:normal;color:#e6212b;']);
var BibYear = _styledComponents2.default.span.withConfig({
  displayName: 'Project__BibYear',
  componentId: 'd9zx3a-8'
})(['font-style:normal;']);

var BibPublished = _styledComponents2.default.span.withConfig({
  displayName: 'Project__BibPublished',
  componentId: 'd9zx3a-9'
})(['font-style:normal;']);

var BibEntry = function BibEntry(_ref, i) {
  var authors = _ref.authors,
      title = _ref.title,
      year = _ref.year,
      link = _ref.link,
      published = _ref.published;
  return _react2.default.createElement(
    BibItem,
    { key: i },
    _react2.default.createElement(
      BibLink,
      { href: link, target: '_blank' },
      _react2.default.createElement(
        BibAuthors,
        null,
        authors
      ),
      ', ' + title + ', ',
      published && _react2.default.createElement(
        BibPublished,
        null,
        published + ', '
      ),
      _react2.default.createElement(
        BibYear,
        null,
        year
      )
    )
  );
};

var Description = function Description(_ref2) {
  var children = _ref2.children;
  return children.split('\n').map(function (line, key) {
    return _react2.default.createElement(
      Text,
      { key: key },
      line
    );
  });
};

exports.default = function (_ref3, i) {
  var title = _ref3.title,
      description = _ref3.description,
      papers = _ref3.papers;
  return _react2.default.createElement(
    Project,
    { key: i },
    _react2.default.createElement(
      ProjectContent,
      null,
      _react2.default.createElement(
        Heading,
        null,
        title
      ),
      _react2.default.createElement(
        Description,
        null,
        description
      ),
      _react2.default.createElement(
        BibList,
        null,
        papers.map(BibEntry)
      )
    )
  );
};

/***/ }),

/***/ 239:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BioBox = undefined;

var _templateObject = _taggedTemplateLiteral(['\n    &:hover {\n      background-color: #fff;\n      box-shadow: 0px 0px 17px -4px rgba(115,108,108,1);\n      transform: scale(1.05);\n      //transition: all 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94);\n\n      div>a {opacity: 1}\n    }\n  '], ['\n    &:hover {\n      background-color: #fff;\n      box-shadow: 0px 0px 17px -4px rgba(115,108,108,1);\n      transform: scale(1.05);\n      //transition: all 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94);\n\n      div>a {opacity: 1}\n    }\n  ']),
    _templateObject2 = _taggedTemplateLiteral(['\n    >a {\n      opacity: 0;\n    }\n  '], ['\n    >a {\n      opacity: 0;\n    }\n  ']);

var _styledSystem = __webpack_require__(157);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _styledComponents = __webpack_require__(13);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _styledComponentsBreakpoint = __webpack_require__(45);

var _styledComponentsBreakpoint2 = _interopRequireDefault(_styledComponentsBreakpoint);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var BioBox = exports.BioBox = _styledComponents2.default.div.withConfig({
  displayName: 'Bio__BioBox',
  componentId: 'sc-13auz32-0'
})(['margin-left:5px;margin-right:5px;flex:1 1 350px;padding:0.6rem;@supports (display:grid){margin:0;}display:flex;align-items:flex-start;transition:all 0.2s cubic-bezier(0.25,0.46,0.45,0.94);', ''], (0, _styledComponentsBreakpoint2.default)('desktop')(_templateObject));

var MediaFigure = _styledComponents2.default.figure.withConfig({
  displayName: 'Bio__MediaFigure',
  componentId: 'sc-13auz32-1'
})(['margin-right:1rem;max-width:96px;max-height:96px;border-radius:50%;border:5px solid #fff;overflow:hidden;']);

var MediaBody = _styledComponents2.default.div.withConfig({
  displayName: 'Bio__MediaBody',
  componentId: 'sc-13auz32-2'
})(['flex:1;']);

var Heading = _styledComponents2.default.h4.withConfig({
  displayName: 'Bio__Heading',
  componentId: 'sc-13auz32-3'
})(['font-family:"Exo 2",serif;font-style:normal;font-weight:600;line-height:27px;font-size:1rem;letter-spacing:0.1em;text-transform:uppercase;margin:0 0 1rem 0;']);

var Bio = _styledComponents2.default.p.withConfig({
  displayName: 'Bio',
  componentId: 'sc-13auz32-4'
})(['', ' ', ' ', ''], _styledSystem.typography, _styledSystem.color, _styledSystem.space);
Bio.defaultProps = {
  m: 0,
  p: 0,
  fontFamily: 'body',
  fontSize: 2,
  fontWeight: 1,
  lineHeight: 'small',
  color: 'midContrast'
};

var ContactBox = _styledComponents2.default.div.withConfig({
  displayName: 'Bio__ContactBox',
  componentId: 'sc-13auz32-5'
})(['display:flex;align-items:flex-start;flex-wrap:nowrap;margin-bottom:1rem;> a{width:33.33%;text-align:center;font-size:0.833rem;font-weight:normal !important;color:#828282 !important;padding:0.3rem;border:1px solid #edebeb;margin-right:5px;transition:all 0.2s cubic-bezier(0.25,0.46,0.45,0.94);&:hover{background-color:#edebeb;}}', ''], (0, _styledComponentsBreakpoint2.default)('desktop')(_templateObject2));

exports.default = function (_ref, i) {
  var name = _ref.name,
      bio = _ref.bio,
      img = _ref.img,
      contact = _ref.contact;
  return _react2.default.createElement(
    BioBox,
    { key: i },
    _react2.default.createElement(
      MediaFigure,
      null,
      _react2.default.createElement('img', { src: './bio/' + (img || 'hal_9000.jpg'), alt: img })
    ),
    _react2.default.createElement(
      MediaBody,
      null,
      _react2.default.createElement(
        Heading,
        null,
        name,
        ' '
      ),
      _react2.default.createElement(
        Bio,
        null,
        bio,
        ' '
      ),
      _react2.default.createElement(
        ContactBox,
        null,
        contact.mail && _react2.default.createElement(
          'a',
          { href: 'mailto:' + contact.mail },
          'email'
        ),
        contact.github && _react2.default.createElement(
          'a',
          { href: 'https://github.com/' + contact.github, target: '_blank' },
          'github'
        ),
        contact.twitter && _react2.default.createElement(
          'a',
          { href: 'https://twitter.com/' + contact.twitter, target: '_blank' },
          'twitter'
        ),
        contact.website && _react2.default.createElement(
          'a',
          { href: 'https://' + contact.website, target: '_blank' },
          'website'
        )
      )
    )
  );
};

/***/ }),

/***/ 240:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PeopleGrid = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _styledComponents = __webpack_require__(13);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PeopleGrid = exports.PeopleGrid = _styledComponents2.default.div.withConfig({
  displayName: 'PeopleGrid',
  componentId: 'lkr7k-0'
})(['display:flex;flex-wrap:wrap;display:grid;grid-template-columns:repeat(auto-fill,minmax(350px,1fr));grid-auto-rows:minmax(150px,auto);grid-gap:3rem;']);

exports.default = function (_ref) {
  var children = _ref.children,
      id = _ref.id;
  return _react2.default.createElement(
    PeopleGrid,
    { id: id },
    children
  );
};

/***/ }),

/***/ 47:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _templateObject = _taggedTemplateLiteral(['\n    padding: 10rem 5rem;\n\n    @media screen and (orientation:portrait) {\n      padding: 10rem 10rem;\n    }\n  '], ['\n    padding: 10rem 5rem;\n\n    @media screen and (orientation:portrait) {\n      padding: 10rem 10rem;\n    }\n  ']),
    _templateObject2 = _taggedTemplateLiteral(['\n    padding: 10rem 5rem;\n  '], ['\n    padding: 10rem 5rem;\n  ']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactStatic = __webpack_require__(22);

var _styledComponents = __webpack_require__(13);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _styledSystem = __webpack_require__(157);

var _styledComponentsBreakpoint = __webpack_require__(45);

var _styledComponentsBreakpoint2 = _interopRequireDefault(_styledComponentsBreakpoint);

var _Head = __webpack_require__(153);

var _Head2 = _interopRequireDefault(_Head);

var _Navigation = __webpack_require__(154);

var _Navigation2 = _interopRequireDefault(_Navigation);

var _Page = __webpack_require__(182);

var _Page2 = _interopRequireDefault(_Page);

var _Hero = __webpack_require__(233);

var _Hero2 = _interopRequireDefault(_Hero);

var _Specialty = __webpack_require__(237);

var _Specialty2 = _interopRequireDefault(_Specialty);

var _Project = __webpack_require__(238);

var _Project2 = _interopRequireDefault(_Project);

var _Bio = __webpack_require__(239);

var _Bio2 = _interopRequireDefault(_Bio);

var _PeopleGrid = __webpack_require__(240);

var _PeopleGrid2 = _interopRequireDefault(_PeopleGrid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
//

// import logoImg from '../logo.png'


var SpecialtyContainer = _styledComponents2.default.div.withConfig({
  displayName: 'Home__SpecialtyContainer',
  componentId: 'sc-1ffwrsf-0'
})(['']);

var TeamsContainer = _styledComponents2.default.div.withConfig({
  displayName: 'Home__TeamsContainer',
  componentId: 'sc-1ffwrsf-1'
})(['background:#F5F2F2;padding:6rem 1rem;', ' ', ''], (0, _styledComponentsBreakpoint2.default)('tablet')(_templateObject), (0, _styledComponentsBreakpoint2.default)('desktop')(_templateObject2));

var TeamHeading = _styledComponents2.default.h3.withConfig({
  displayName: 'Home__TeamHeading',
  componentId: 'sc-1ffwrsf-2'
})(['', ' ', ' letter-spacing:0.03em;text-transform:uppercase;'], _styledSystem.typography, _styledSystem.color);
TeamHeading.defaultProps = {
  mt: 2,
  mb: 1,
  p: 0
};

var SubTeamHeading = _styledComponents2.default.h5.withConfig({
  displayName: 'Home__SubTeamHeading',
  componentId: 'sc-1ffwrsf-3'
})(['', ' ', ' letter-spacing:0.03em;text-transform:uppercase;'], _styledSystem.typography, _styledSystem.color);
SubTeamHeading.defaultProps = {
  mt: 2,
  mb: 1,
  p: 0,
  color: 'midContrast'
};

exports.default = (0, _reactStatic.withRouteData)((0, _reactStatic.withSiteData)(function (props) {
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(_Head2.default, {
      title: props.title + ' | ' + props.tagline,
      description: props.description,
      tagline: props.tagline,
      tags: props.tags,
      image: 'https://bit-ml.github.io/tile.png' }),
    _react2.default.createElement(_Navigation2.default, { pageName: 'home' }),
    _react2.default.createElement(
      _Page2.default,
      null,
      _react2.default.createElement(_Hero2.default, { props: props }),
      _react2.default.createElement(
        SpecialtyContainer,
        { id: 'research' },
        props.specialties.map(function (specialty, i) {
          return _react2.default.createElement(
            _Specialty2.default,
            { props: specialty, key: i, bgIdx: i },
            specialty.projects.map(_Project2.default)
          );
        })
      ),
      _react2.default.createElement(
        TeamsContainer,
        { id: 'teams' },
        props.teams.map(function (team) {
          return _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              TeamHeading,
              null,
              team.direction
            ),
            Object.entries(team.subteams).map(function (_ref, i) {
              var _ref2 = _slicedToArray(_ref, 2),
                  subteamName = _ref2[0],
                  people = _ref2[1];

              return _react2.default.createElement(
                'div',
                { key: i },
                _react2.default.createElement(
                  SubTeamHeading,
                  null,
                  subteamName
                ),
                _react2.default.createElement(
                  _PeopleGrid2.default,
                  { id: subteamName },
                  people.map(_Bio2.default)
                )
              );
            })
          );
        })
      )
    )
  );
}));

/***/ })

});


// WEBPACK FOOTER //
// templates/src/pages/Home.c47ce598.js